/**
 * ================================================================
 * Bisou Rivage — bisou-mockup.js
 * ================================================================
 * Bouton « En savoir plus » dans la rangée d'achat (#bisou-mockup-btn).
 * Clic → dans la colonne d'achat elle-même, les boutons s'effacent et
 * une carte a sommaire prend leur place — Œuvre, Artiste, Nos tirages et
 * ses six fiches, toujours visibles a gauche, le contenu a droite —,
 * calée en absolu sur .bisou-s1-wrapper : ni fixed, ni calque, comme le
 * panneau « édition limitée ». Mobile : même DOM dans le flux, et un rail
 * natif de cartes portrait sous le pouce. Panier et retour sous la carte.
 * ================================================================
 */
(function () {
  'use strict';

  /* Pont i18n : les libellés viennent de sections/bisou-mockup.liquid, le JS n'a pas
     accès au filtre | t. Chaque appel garde son repli français. */
  var I18N = {};
  try { I18N = JSON.parse((document.getElementById('bisou-mockup-i18n') || {}).textContent || '{}'); } catch (e) {}
  function t(key, fallback) {
    var v = I18N[key];
    return (typeof v === 'string' && v) ? v : fallback;
  }
  function tfill(key, fallback, vars) {
    var s = t(key, fallback);
    for (var k in vars) {
      if (Object.prototype.hasOwnProperty.call(vars, k)) s = s.split('{' + k + '}').join(vars[k]);
    }
    return s;
  }

  var A_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h16M14 6l6 6-6 6"/></svg>';
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  function init() {
    var section = document.querySelector('.bisou-mockup-section');
    var anchor = document.getElementById('bisou-mockup-btn');
    var mount = document.getElementById('bisou-mockup-mount');
    if (!section || !anchor || !mount || anchor.dataset.built) return;
    var srcs = Array.prototype.slice.call(section.querySelectorAll('.bm-src'));
    if (!srcs.length) return;
    anchor.dataset.built = '1';

    var num = function (s) { return s.getAttribute('data-num'); };
    var title = function (s) { return s.getAttribute('data-title'); };
    var media = function (s) { return s.querySelector('.bm-src-media'); };
    var body = function (s) { return s.querySelector('.bm-src-body'); };

    var mq = window.matchMedia('(min-width: 900px)');
    var mode = null;
    /* L'ouvreur du volet courant. Le volet est reconstruit a chaque bascule
       de palier ; les declencheurs cables une seule fois (« + d'infos »)
       passent par cette reference pour ne jamais viser un volet retire. */
    var ouvrirCourant = null;

    /* ═══════════ DIMENSIONS ADAPTATIVES ═══════════
       Le volet « Dimensions » (corps contenant un <table> A4/A3/A2) est transformé :
       faux-cadre orienté (H/V selon le produit) + couleurs distinctes par élément,
       et tableau réduit au SEUL format choisi par le client + lien « voir plus ». */
    var DIM_COLORS = { 'Cadre': '#2f2a24', 'Papier': '#9a948a', 'Image': '#6e8aa6', 'Ouv. PP': '#b8985e' };
    var DIM_ORDER = ['Cadre', 'Papier', 'Ouv. PP', 'Image'];
    var DIM_LABEL = { 'Cadre': t('dim_cadre', 'Cadre'), 'Papier': t('dim_papier', 'Papier'), 'Ouv. PP': t('dim_pp', 'Passe-partout'), 'Image': t('dim_image', 'Image') };
    var dimData = null;

    function parseDimPair(s) { if (!s) return null; var m = String(s).match(/(\d+)\D+(\d+)/); return m ? [+m[1], +m[2]] : null; }

    function parseDimTable(table) {
      var head = table.querySelectorAll('thead th, thead td');
      var fmts = [];
      for (var i = 1; i < head.length; i++) fmts.push(head[i].textContent.trim().toUpperCase());
      var data = {};
      Array.prototype.forEach.call(table.querySelectorAll('tbody tr'), function (tr) {
        var cells = tr.querySelectorAll('td, th'); if (cells.length < 2) return;
        var measure = cells[0].textContent.trim();
        for (var j = 1; j < cells.length; j++) { var f = fmts[j - 1]; if (!f) continue; (data[f] || (data[f] = {}))[measure] = cells[j].textContent.trim(); }
      });
      return Object.keys(data).length ? data : null;
    }

    function productOrient() { var a = document.getElementById('rv5-bloc-associated'); return (a && a.dataset.orientation) === 'horizontal' ? 'horizontal' : 'vertical'; }
    function selectedFmt() { var r = document.querySelector('.rv5-format-row.active'); var f = r && (r.getAttribute('data-f') || '').toUpperCase(); return (f === 'A2' || f === 'A3' || f === 'A4') ? f : null; }

    /* Couleur du cadre selon la finition choisie (lit le libellé couleur de la fiche). */
    function frameColor() {
      var el = document.getElementById('rv5-color-label');
      /* Meme piege que le chronometre de resize : une variable « t » ici
         masquerait le helper i18n t() pour toute la fonction. */
      var label = (el ? el.textContent : '').toLowerCase();
      if (/noir|black/.test(label)) return '#2b2724';
      if (/blanc|white/.test(label)) return '#d6d2ca';
      if (/ch.?ne|oak/.test(label)) return '#b8895a';
      if (/bouleau|birch/.test(label)) return '#d8c39c';
      if (/sans|none|papier|paper/.test(label)) return '#cfcabe';
      return '#2f2a24';
    }

    /* Schéma annoté : CADRE CENTRÉ, chaque élément étiqueté par une ligne de rappel fine
       + pastille colorée. Pointillés aérés. La couleur du cadre suit la finition choisie. */
    function dimSvg(dRaw, orient) {
      function P(k, fb) { var p = parseDimPair(dRaw && dRaw[k]); p = p || fb; return orient === 'horizontal' ? [p[1], p[0]] : p; }
      var cad = P('Cadre', [500, 700]);
      var pap = P('Papier', [Math.round(cad[0] * 0.84), Math.round(cad[1] * 0.85)]);
      var ouv = P('Ouv. PP', [Math.round(cad[0] * 0.78), Math.round(cad[1] * 0.83)]);
      var img = P('Image', [Math.round(cad[0] * 0.74), Math.round(cad[1] * 0.8)]);
      var fw = cad[0], fh = cad[1];
      var pad = 20, side = Math.max(220, Math.round(fw * 0.52));
      /* La reserve de droite porte les legendes ; a GAUCHE il n'y a rien a
         mettre. Elle y etait quand meme : un quart de la boite vide, donc un
         dessin reduit d'autant a largeur egale — c'est de la que venait le
         « illisible » du 29/08. */
      var marge = 24;
      var vbW = marge + fw + side, vbH = pad + fh + pad;
      var cx = marge + fw / 2, cy = vbH / 2;
      var fcol = frameColor();
      function rect(d, fill, stroke, sw, dash) { var x = (cx - d[0] / 2).toFixed(1), y = (cy - d[1] / 2).toFixed(1); return '<rect x="' + x + '" y="' + y + '" width="' + d[0] + '" height="' + d[1] + '" rx="4" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + sw + '"' + (dash ? ' stroke-dasharray="' + dash + '"' : '') + '/>'; }
      var s = '<svg class="bm-dimsvg" viewBox="0 0 ' + Math.round(vbW) + ' ' + Math.round(vbH) + '" role="img" aria-label="' + t('anatomy_aria', 'Anatomie du tirage encadré') + '">';
      s += rect(cad, '#f4efe6', fcol, 14);
      s += rect(pap, '#ffffff', '#9a948a', 2, '18 13');
      s += rect(ouv, 'none', '#b8985e', 2.5);
      s += rect(img, '#cfdae4', '#6e8aa6', 2.5);
      var labelX = cx + cad[0] / 2 + 24;
      var items = [['Cadre', cad[0], fcol], ['Papier', pap[0], DIM_COLORS['Papier']], ['Ouv. PP', ouv[0], DIM_COLORS['Ouv. PP']], ['Image', img[0], DIM_COLORS['Image']]];
      var rows = [0.15, 0.38, 0.62, 0.85];
      items.forEach(function (it, i) {
        var col = it[2], ry = cy - fh / 2 + fh * rows[i], sx = cx + it[1] / 2;
        s += '<line x1="' + sx.toFixed(1) + '" y1="' + ry.toFixed(1) + '" x2="' + (labelX - 9) + '" y2="' + ry.toFixed(1) + '" stroke="#d3ccbe" stroke-width="1.3"/>';
        s += '<circle cx="' + sx.toFixed(1) + '" cy="' + ry.toFixed(1) + '" r="4.5" fill="' + col + '"/>';
        s += '<text x="' + labelX + '" y="' + (ry + 9).toFixed(1) + '" font-family="Space Mono, monospace" font-size="33" fill="' + col + '">' + DIM_LABEL[it[0]] + '</text>';
      });
      s += '</svg>';
      return s;
    }

    function dimFmtButtons(active) {
      if (!dimData) return '';
      var html = '<div class="bm-dimfmts">';
      ['A4', 'A3', 'A2'].forEach(function (f) { if (!dimData[f]) return; html += '<button type="button" class="bm-dimfmt' + (f === active ? ' on' : '') + '" data-f="' + f + '">' + f + '</button>'; });
      return html + '</div>';
    }

    function dimTable(fmt, dRaw) {
      var html = '<table class="bm-dimtable"><tbody><tr class="bm-dimtable-h"><td colspan="2">' + tfill('dim_format', 'Format {fmt}', { fmt: fmt }) + '</td></tr>';
      DIM_ORDER.forEach(function (k) {
        var v = dRaw && dRaw[k]; if (!v) return;
        if (!/mm/i.test(v)) v += ' mm';
        var col = (k === 'Cadre') ? frameColor() : DIM_COLORS[k];
        html += '<tr><td><span class="bm-dimdot" style="background:' + col + '"></span><span style="color:' + col + '">' + DIM_LABEL[k] + '</span></td><td>' + v + '</td></tr>';
      });
      html += '</tbody></table>';
      return html;
    }

    function renderDimPanel(media, body) {
      var fmt = (body && body.getAttribute('data-dim-fmt')) || selectedFmt() || 'A2';
      var orient = productOrient();
      var dRaw = dimData && dimData[fmt];
      if (media) media.innerHTML = '<div class="bm-dimcap">' + tfill('anatomy_caption_html', 'Anatomie d\'un tirage encadré — exemple {fmt}', { fmt: fmt }) + '</div>' + dimSvg(dRaw, orient);
      if (body) {
        var intro = body.getAttribute('data-dim-intro') || '';
        body.innerHTML = intro + dimTable(fmt, dRaw) + '<a class="bm-dimmore" href="/pages/formats-dimensions">' + t('see_all_formats', 'Voir tous les formats →') + '</a>';
      }
    }

    function enhanceDims(scope) {
      if (!scope || !scope.querySelectorAll) return;
      Array.prototype.forEach.call(scope.querySelectorAll('.bm-src-body'), function (body) {
        if (body.dataset.dimDone) return;
        var table = body.querySelector('table'); if (!table) return;
        if (!dimData) dimData = parseDimTable(table);
        if (!dimData) return;
        body.dataset.dimDone = '1';
        var intro = body.querySelector('p'); body.setAttribute('data-dim-intro', intro ? intro.outerHTML : '');
        var media = body.parentNode && body.parentNode.querySelector('.bm-src-media');
        if (media) media.classList.add('bm-dim-media');
        body.classList.add('bm-dim-body');
        renderDimPanel(media, body);
      });
    }

    function refreshDims() {
      Array.prototype.forEach.call(document.querySelectorAll('.bm-dim-body'), function (body) {
        body.removeAttribute('data-dim-fmt');
        renderDimPanel(body.parentNode && body.parentNode.querySelector('.bm-dim-media'), body);
      });
    }
    document.addEventListener('bisou:variant-change', refreshDims);
    /* clic sur un bouton format dans un panneau dimensions → aperçu local (sans toucher au panier) */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.bm-dimfmt');
      if (!b) return;
      var body = b.closest('.bm-dim-body'); if (!body) return;
      body.setAttribute('data-dim-fmt', b.getAttribute('data-f'));
      renderDimPanel(body.parentNode && body.parentNode.querySelector('.bm-dim-media'), body);
    });

    /* Desktop only: one short wheel gesture advances exactly one product block.
       Targets are based on stable block wrappers; inner content can finish
       rendering without changing the order or making a block unreachable. */
    function installDesktopMagneticScroll() {
      try {
        if (new URLSearchParams(window.location.search).get('product_scroll') === 'free') {
          document.documentElement.classList.add('bisou-product-scroll-free');
        }
      } catch (e) {}
      if (document.documentElement.classList.contains('bisou-product-scroll-free')) return;
      if (window.__bisouProductMagneticScroll) return;
      window.__bisouProductMagneticScroll = true;

      /* ── Machine d'état simple ──
         Zone SLIDES (bloc 1 « la fiche », bloc 2 « Associez le ») : la molette
         est entièrement contrôlée, un geste = un bloc. Zone LIBRE (sous le bloc
         2) : scroll naturel ; en remontant, le premier geste RECALE fermement le
         bloc 2, le geste suivant remonte à la fiche. */

      /* `?product_scroll=debug` affiche les nombres du calage en bas a gauche.
         Meme famille que `?product_scroll=free` juste au-dessus : un parametre
         d'URL, rien de visible sans lui. */
      var DEBUG = false;
      try { DEBUG = new URLSearchParams(window.location.search).get('product_scroll') === 'debug'; } catch (e) {}
      var debugBox = null;
      function debug(txt) {
        if (!DEBUG) return;
        if (!debugBox) {
          debugBox = document.createElement('pre');
          debugBox.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:9999;margin:0;padding:8px 10px;background:rgba(0,0,0,.85);color:#4ade80;font:11px/1.55 monospace;white-space:pre;pointer-events:none;border-radius:5px';
          document.body.appendChild(debugBox);
        }
        debugBox.textContent = txt;
      }

      var acc = 0;
      var accDir = 0;
      var accTimer = null;
      var locked = false;
      var lockTimer = null;
      var animating = false;
      var animationId = 0;
      var dotsRoot = null;

      /* ═══ L'INERTIE DU TRACKPAD (Max, 27/08 : « sur mac ça a tendance à aller
         encore plus loin ») ═══
         Une molette de souris envoie des crans espacés ; un trackpad envoie une
         traînée qui continue près d'une seconde après que les doigts ont quitté
         la surface. Un verrou à durée fixe expirait au milieu de cette traînée,
         et ce qu'il en restait suffisait à déclencher le bloc suivant : un
         geste, deux blocs.

         Le verrou ne compte donc plus le temps écoulé mais le SILENCE. Il ne se
         lève qu'après REPOS millisecondes sans un seul événement, et chaque
         événement avalé pendant le verrou repousse l'échéance. Le plancher passé
         à `lock()` laisse d'abord l'animation finir ; PLAFOND garantit qu'une
         molette tournée sans relâche finit toujours par reprendre la main. */
      var REPOS = 140;
      var PLAFOND = 1600;
      var lockFloor = 0;
      var lockHard = 0;

      function planifierDeverrouillage() {
        clearTimeout(lockTimer);
        var maintenant = performance.now();
        var reste = Math.max(REPOS, lockFloor - maintenant);
        reste = Math.min(reste, Math.max(0, lockHard - maintenant));
        lockTimer = setTimeout(function () {
          locked = false;
          acc = 0;
          accDir = 0;
        }, reste);
      }

      function lock(ms) {
        locked = true;
        var maintenant = performance.now();
        lockFloor = maintenant + ms;
        lockHard = maintenant + Math.max(ms, PLAFOND);
        planifierDeverrouillage();
      }

      function absoluteTop(el) {
        var rect = el.getBoundingClientRect();
        return window.scrollY + rect.top;
      }

      /* ── LES DEUX BLOCS ──
         Il y en avait trois tant que le mockup occupait son propre écran. Depuis
         la pile de cartes (26/08), `#bisou-mockup-mount` reste vide sur
         ordinateur : le volet carte postale ne le remplit plus du tout. Le bloc du milieu mesurait donc zéro, la liste n'atteignait jamais
         trois, et TOUT le mécanisme se désarmait en silence — plus de calage,
         plus de points, sans la moindre erreur en console. On ne compte plus que
         ce qui existe : la fiche, puis « Associez le ». */
      function slides() {
        var first = document.querySelector('.bisou-s1-wrapper');
        var second = document.getElementById('rv5-bloc-associated');
        var secondGrid = second && second.querySelector('.rv5-associated-grid');
        if (!first || !second) return [];
        if (!first.offsetParent || !second.offsetParent) return [];
        if (second.getBoundingClientRect().height < 20) return [];

        var vh = window.innerHeight;

        /* Le centre du tirage, mesuré DANS LA FENÊTRE, colonne collée.
           La colonne image est `sticky top:0, height:100vh` : une fois passé le
           premier écran, sa position dans la fenêtre ne bouge plus. L'écart
           entre son bord haut et le centre du tirage, lui, ne dépend jamais du
           défilement — on peut donc le lire à n'importe quel moment et s'en
           servir de cible.

           ── On mesure l'IMAGE, plus le cadre (Max, 28/08) ──
           `.rv5-media-frame` est le conteneur de la galerie : il porte aussi la
           liste des diapos et la rangée de boutons sous les images. Son centre
           tombe donc SOUS celui du tirage, et les vignettes d'« Associez le »
           arrivaient une vingtaine de pixels trop bas. « un tout petit
           décalage », mesuré a 20 px sur sa capture.

           On prend donc la plus grande image du cadre. Les diapos vivent côte à
           côte sur une même rangée : laquelle est active ne change rien à la
           hauteur, qui est la seule chose qu'on lise ici. Sans image mesurable
           — pas encore chargée — on retombe sur le cadre, qui vaut mieux que
           rien le temps que `recalerBientot` repasse au chargement. */
        function centreDuCadre() {
          var frame = document.querySelector('.rv5-media-frame');
          var col = document.querySelector('.product__media-wrapper');
          if (!frame || !col) return null;
          var cr = col.getBoundingClientRect();
          if (cr.height < 20) return null;

          var meilleure = null, aire = 0;
          Array.prototype.forEach.call(frame.querySelectorAll('img'), function (img) {
            var r = img.getBoundingClientRect();
            if (r.width < 40 || r.height < 40) return;
            var a = r.width * r.height;
            if (a > aire) { aire = a; meilleure = r; }
          });

          var fr = meilleure || frame.getBoundingClientRect();
          if (fr.height < 20) return null;
          return (fr.top - cr.top) + fr.height / 2;
        }

        /* Bloc 2 : le centre des vignettes se pose sur le centre du tirage
           (Max, 27/08 : « les images d'Associez le alignées avec le centre du
           mockup »). Jusqu'ici c'était le HAUT du titre sur le HAUT du cadre —
           une autre ligne d'horizon, et les images tombaient plus bas.

           L'ancre est la vignette elle-même, pas le bloc : le bloc porte aussi
           son titre au-dessus et le bouton mur en dessous, et centrer sur lui
           ferait flotter les images sous la ligne du tirage. Sans vignette
           mesurable — grille pas encore remplie, cadre pas encore chargé — on
           retombe sur un centrage fenêtre, qui vaut toujours mieux que rien. */
        function assocY(section) {
          var ancre = section.querySelector('.rv5-assoc-card-img') || secondGrid;
          if (!ancre || ancre.getBoundingClientRect().height < 20) ancre = section;
          var h = ancre.getBoundingClientRect().height;
          var centre = centreDuCadre();
          if (centre === null) return Math.max(0, Math.round(absoluteTop(ancre) + h / 2 - vh / 2));
          return Math.max(0, Math.round(absoluteTop(ancre) + h / 2 - centre));
        }

        /* Bloc 1 : le HAUT DE LA PAGE, pas le centre du bloc.
           On centrait le bloc dans la fenetre, ce qui posait la cible a une
           quarantaine de pixels — la moitie du header — et laissait le header
           coupe en deux. Max, 28/08 : « scroll du haut doit bien aller jusqu'a
           afficher le header ». Zero, donc : un geste vers le haut depuis
           « Associez le » ramene la page a son sommet, header compris. C'est
           aussi ce qui oblige la barre d'annonce a s'effacer sur une fenetre
           basse — voir la regle `max-height` dans bisou-mockup.css. */
        return [
          { el: first, y: 0 },
          { el: second, visualEl: secondGrid || second, y: assocY(second) }
        ];
      }

      /* ═══ LA SORTIE DU PRODUIT (Max, 28/08) ═══
         « Après Associez le, quand le client veut descendre, le scroll est un
         peu long. » Sous le bloc 2 il y a la reserve, puis la fin de la grille
         produit, puis la section suivante — l'artiste. A la molette c'est une
         traversee de vide avant que quelque chose n'arrive.

         Une cible de plus, donc : le haut de la premiere section qui suit le
         produit. Un geste depuis « Associez le » et on est dehors.

         Elle ne se pose pas au ras du haut de la fenetre : Max, une heure
         apres l'avoir eue, « l'aide est un peu trop, diminue un peu ». La
         section suivante arrive donc au quart de la hauteur — le geste
         parcourt trois quarts d'ecran au lieu d'un entier, et la fin du
         produit reste visible au-dessus, comme une transition plutot qu'une
         coupe. SORTIE_HAUT est la part de fenetre laissee au-dessus. Elle ne vaut QUE vers le bas — en remontant depuis
         l'artiste, le geste ramene directement a « Associez le », c'est le
         chemin inverse que Max demande — et elle ne compte pas parmi les
         points : ce n'est pas un bloc du produit, c'est sa porte.

         On cherche la section par le DOM et non par son nom : le gabarit peut
         changer d'ordre dans l'editeur, et `.bisou-mockup-section`, qui suit
         immediatement le produit, est un porte-donnees masque — on saute ce
         qui ne mesure rien. */
      var SORTIE_HAUT = 0.25;
      function sortie(list) {
        var bloc = document.getElementById('rv5-bloc-associated');
        var section = bloc && bloc.closest('.shopify-section');
        var suivante = section && section.nextElementSibling;
        while (suivante && suivante.offsetHeight < 20) suivante = suivante.nextElementSibling;
        if (!suivante) return null;
        var maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        var y = Math.round(absoluteTop(suivante) - window.innerHeight * SORTIE_HAUT);
        if (y <= list[1].y + 40) return null;
        return Math.min(y, maxScroll);
      }

      /* ═══ LA RÉSERVE SOUS « ASSOCIEZ LE » ═══
         Le document doit descendre assez pour que le bloc atteigne le centre,
         et la colonne image doit rester collée jusque-là. Les deux tiennent à
         la même chose : le bas de la grille produit doit tomber à
         `cible + 100vh`. Une colonne collante de 100vh décolle exactement là.

         ── Pourquoi ce n'est plus un `<div>` (Max, 28/08) ──
         Ça l'était, et ça n'a jamais rien fait. `assets/base.css` porte, très
         loin de tout ceci, la règle d'hygiène `div:empty { display: none }`.
         Une cale est un div vide par définition : elle était créée, on lui
         posait sa hauteur, et le navigateur ne l'affichait pas. `offsetHeight`
         renvoyait zéro, le code se croyait à jour, et le trou restait. C'est ce
         que l'encart de diagnostic a fini par dire mot pour mot :
         « reserve 192 (posee 0) ».

         La réserve est donc devenue le `padding-bottom` du bloc lui-même. Rien
         de vide à afficher, aucune règle globale à contourner, un nœud de moins
         dans la page. Le style en ligne l'emporte sur le `padding-bottom: 0`
         de la feuille, qui n'est pas en `!important`.

         Si la hauteur voulue est négative, le bloc déborde déjà l'écran : on ne
         peut pas raccourcir du contenu, on retombe à zéro. */
      /* ═══ LE DECOLLAGE EST PILOTE, PLUS SUBI ═══
         Deux tentatives ont essaye de faire coincider le decollage naturel de
         la colonne collante avec le point de calage, en dimensionnant la
         reserve : la premiere deduisait la geometrie de la zone de grille, la
         seconde la mesurait. Les deux ont laisse l'ecart en place — « Associez
         le » montait seul pendant que le tirage restait cloue.

         On arrete de negocier. Passe le point de calage, on decale le `top` de
         la colonne d'autant que le defilement : elle remonte donc exactement a
         la vitesse de la page. Rien a deduire, rien a mesurer, aucune hypothese
         sur la grille. Un `sticky` a `top: -N` se pose a N pixels au-dessus du
         bord haut de la fenetre, et le seul garde-fou du navigateur — ne jamais
         remonter plus haut que la position naturelle — joue dans notre sens.

         `setProperty(..., 'important')` parce que la feuille de style pose
         `top: 0 !important` sur cette colonne : un style en ligne ordinaire
         perdrait le duel de specificite et ne ferait rien du tout.

         La reserve garde son autre role, celui qu'elle remplit bien : empecher
         le decollage TROP TOT, avant que le bloc ait fini d'arriver au centre.
         Elle ne s'occupe plus du trop tard, qui est desormais impossible. */
      var topPose = null;
      function suivreDecollage(cible) {
        var col = document.querySelector('.product__media-wrapper');
        if (!col) return;
        var delta = Math.round(window.scrollY - cible);
        var valeur = (mq.matches && delta > 0) ? (-delta) + 'px' : '';
        if (valeur === topPose) return;
        topPose = valeur;
        if (valeur) col.style.setProperty('top', valeur, 'important');
        else col.style.removeProperty('top');
      }

      function relacherColonne() {
        var col = document.querySelector('.product__media-wrapper');
        if (col) col.style.removeProperty('top');
        topPose = null;
      }

      function blocAssocie() { return document.getElementById('rv5-bloc-associated'); }

      function reservePosee() {
        var bloc = blocAssocie();
        if (!bloc) return 0;
        return Math.round(parseFloat(bloc.style.paddingBottom) || 0);
      }

      function viderReserve() {
        var bloc = blocAssocie();
        if (bloc) bloc.style.paddingBottom = '';
      }

      function ensureCenteringRoom(list) {
        var col = document.querySelector('.product__media-wrapper');
        var grille = col && col.closest('.product');
        var bloc = blocAssocie();
        if (!grille || !bloc) return;

        var vh = window.innerHeight;
        var actuelle = reservePosee();
        var basNaturel = absoluteTop(grille) + grille.getBoundingClientRect().height - actuelle;
        var voulue = Math.max(0, Math.min(Math.round(list[1].y + vh - basNaturel), Math.round(vh)));

        var ancre = list[1].el.querySelector('.rv5-assoc-card-img');
        /* Le meme choix d'ancre que centreDuCadre : sinon l'encart afficherait
           un nombre que le calage n'utilise pas, et mentirait poliment. */
        var cadre = null, aireCadre = 0;
        var frameDebug = document.querySelector('.rv5-media-frame');
        if (frameDebug) {
          Array.prototype.forEach.call(frameDebug.querySelectorAll('img'), function (img) {
            var r = img.getBoundingClientRect();
            if (r.width < 40 || r.height < 40) return;
            var a = r.width * r.height;
            if (a > aireCadre) { aireCadre = a; cadre = img; }
          });
          if (!cadre) cadre = frameDebug;
        }
        var ecart = Math.round(window.scrollY - list[1].y);
        debug([
          (Math.abs(ecart) < 3 ? '>>> AU CALAGE <<<' : 'ecart cible  ' + (ecart > 0 ? '+' : '') + ecart),
          '',
          'vh           ' + vh,
          'scrollY      ' + Math.round(window.scrollY),
          'cible        ' + list[1].y,
          'sortie       ' + (function () { var p = sortie(list); return p === null ? 'aucune' : p; })(),
          'scroll max   ' + Math.round(document.documentElement.scrollHeight - vh),
          'bas grille   ' + Math.round(basNaturel),
          'reserve      ' + voulue + '  (posee ' + actuelle + ')',
          'top pose     ' + (topPose || '0 (collee)'),
          'col.top      ' + Math.round(col.getBoundingClientRect().top),
          'tirage centre' + (cadre ? Math.round(cadre.getBoundingClientRect().top + cadre.getBoundingClientRect().height / 2) : '?'),
          'vignette c.  ' + (ancre ? Math.round(ancre.getBoundingClientRect().top + ancre.getBoundingClientRect().height / 2) : 'absente')
        ].join(String.fromCharCode(10)));

        if (voulue === actuelle) return;
        bloc.style.paddingBottom = voulue + 'px';
      }

      function visualBottom(slide) {
        var el = slide.visualEl || slide.el;
        return absoluteTop(el) + el.getBoundingClientRect().height;
      }

      function ensureDots(list) {
        if (dotsRoot || list.length !== 2) return;
        dotsRoot = document.createElement('nav');
        dotsRoot.className = 'bmx-slide-dots';
        dotsRoot.setAttribute('aria-label', t('points_nav', 'Navigation de la fiche produit'));
        list.forEach(function (_, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bmx-slide-dot';
          dot.setAttribute('aria-label', tfill('point_bloc', 'Afficher le bloc {n}', { n: index + 1 }));
          dot.addEventListener('click', function () {
            var currentList = slides();
            if (!currentList[index]) return;
            lock(550);
            animateTo(currentList[index].y, function () {
              var l = slides();
              return l[index] ? l[index].y : null;
            });
          });
          dotsRoot.appendChild(dot);
        });
        document.body.appendChild(dotsRoot);
      }

      function updateDots(list) {
        ensureDots(list);
        ensureCenteringRoom(list);
        if (!dotsRoot) return;
        var current = window.scrollY;
        var dernier = list[list.length - 1].el;
        var basDernier = absoluteTop(dernier) + dernier.getBoundingClientRect().height;
        var porte = sortie(list);
        var borne = porte === null ? basDernier : porte - 14;
        var inProductSlides = current >= list[0].y - 60 && current < borne;
        dotsRoot.classList.toggle('is-visible', inProductSlides);
        dotsRoot.setAttribute('aria-hidden', inProductSlides ? 'false' : 'true');
        var active = 0;
        var distance = Infinity;
        list.forEach(function (slide, index) {
          var d = Math.abs(slide.y - current);
          if (d < distance) { distance = d; active = index; }
        });
        Array.prototype.forEach.call(dotsRoot.children, function (dot, index) {
          dot.classList.toggle('is-active', index === active);
          dot.setAttribute('aria-current', index === active ? 'step' : 'false');
        });
      }

      function canScrollInside(target, direction) {
        var node = target && target.nodeType === 1 ? target : null;
        while (node && node !== document.body) {
          var style = getComputedStyle(node);
          var overflow = style.overflowY;
          var scrollable = (overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight + 2;
          if (scrollable) {
            if (direction > 0 && node.scrollTop < node.scrollHeight - node.clientHeight - 2) return true;
            if (direction < 0 && node.scrollTop > 2) return true;
          }
          node = node.parentElement;
        }
        return false;
      }

      /* `recalculer`, facultatif : rend la cible telle qu'elle est MAINTENANT.
         Une fois posee, l'animation attend un instant et regarde si la cible a
         bouge sous elle — une vignette qui finit de charger, une reserve qui
         se recale — et rattrape l'ecart, mais seulement si le visiteur n'a pas
         touche a la page entre-temps. C'est ce qui rend le calage exact sur les
         ecrans ou la mise en page se stabilise apres coup. */
      function animateTo(targetY, recalculer) {
        animationId += 1;
        var id = animationId;
        var from = window.scrollY;
        var distance = targetY - from;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var duration = reduceMotion ? 0 : Math.min(560, Math.max(380, Math.abs(distance) * 0.4));
        var started = performance.now();
        animating = true;

        /* Si la trame ne revient jamais — onglet mis en arriere-plan en pleine
           course — `animating` resterait vrai et la molette serait morte. */
        setTimeout(function () { if (id === animationId) animating = false; }, duration + 400);

        function poser() {
          animating = false;
          if (typeof recalculer !== 'function') return;
          setTimeout(function () {
            if (id !== animationId) return;
            if (Math.abs(window.scrollY - targetY) > 2) return;
            var neuf = recalculer();
            if (typeof neuf !== 'number' || Math.abs(neuf - targetY) < 4) return;
            window.scrollTo(0, neuf);
          }, 220);
        }

        function frame(now) {
          if (id !== animationId) return;
          var progress = duration ? Math.min(1, (now - started) / duration) : 1;
          var eased = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
          window.scrollTo(0, from + distance * eased);
          if (progress < 1) {
            requestAnimationFrame(frame);
          } else {
            poser();
          }
        }
        requestAnimationFrame(frame);
      }

      window.__bisouAnimateTo = animateTo;

      window.addEventListener('wheel', function (event) {
        if (!mq.matches || event.ctrlKey || document.documentElement.classList.contains('bisou-product-scroll-free')) return;

        var direction = event.deltaY > 0 ? 1 : event.deltaY < 0 ? -1 : 0;
        if (!direction || canScrollInside(event.target, direction)) return;

        var list = slides();
        if (list.length !== 2) return;
        updateDots(list);

        var current = window.scrollY;
        var vh = window.innerHeight;
        var first = list[0].y;
        var last = list[1].y;

        var exit = sortie(list);

        /* ── L'INERTIE, D'ABORD ──
           Le verrou qui suit un calage avale TOUT, quelle que soit la zone.
           Avant, un geste vers le bas pose sur « Associez le » etait libere
           des l'arrivee — et la trainee du trackpad emportait la page au-dela.
           Le verrou ne tient que 140 ms apres le dernier evenement, 1,6 s au
           plus : un visiteur qui repart apres une pause n'attend jamais. */
        if (locked || animating) { event.preventDefault(); planifierDeverrouillage(); return; }

        /* ── OU VA-T-ON ? — decide AVANT d'avaler quoi que ce soit ──
           C'etait la faille du petit ecran (Max, 28/08 : « j'arrive pas a
           scroller en bas, pourtant en inspecteur ca marche »). L'ancien code
           faisait preventDefault PUIS cherchait une destination ; quand il n'en
           trouvait pas — la page posee un peu au-dessus de sa cible, le bloc
           le plus proche etant deja le dernier — il avait deja tue le geste.
           Chaque coup de molette mourait dans le vide. En inspecteur la fenetre
           passait sous 900 px et tout ceci se desactivait : « ca marche ».

           Maintenant : pas de destination, pas de preventDefault. Le
           defilement naturel est toujours la sortie de secours. */
        var destination = null;
        var recalcul = null;
        function cibleBloc2() { var l = slides(); return l.length === 2 ? l[1].y : null; }
        function cibleSortie() { var l = slides(); return l.length === 2 ? sortie(l) : null; }

        if (direction > 0) {
          if (current < last - 14) { destination = last; recalcul = cibleBloc2; }
          else if (exit !== null && current < exit - 14) { destination = exit; recalcul = cibleSortie; }
        } else {
          /* En remontant, la porte ne compte pas : depuis l'artiste on revient
             droit sur « Associez le ». Le plafond garde le comportement d'avant
             — plus bas que ca, le visiteur lit la suite et on le laisse. */
          var plafond = (exit !== null ? exit : visualBottom(list[1])) + vh * 0.35;
          if (current > last + 14 && current <= plafond) { destination = last; recalcul = cibleBloc2; }
          else if (current <= last + 14 && current > first + 14) { destination = first; recalcul = function () { return 0; }; }
        }
        if (destination === null) return;

        event.preventDefault();

        if (accDir !== direction) { acc = 0; accDir = direction; }
        acc += Math.abs(event.deltaY) * (event.deltaMode === 1 ? 16 : 1);
        clearTimeout(accTimer);
        accTimer = setTimeout(function () { acc = 0; }, 160);
        if (acc < 50) return;
        acc = 0;

        lock(550);
        animateTo(destination, recalcul);
      }, { passive: false });

      window.addEventListener('scroll', function () {
        if (!mq.matches) return;
        var list = slides();
        if (list.length !== 2) return;
        suivreDecollage(list[1].y);
        updateDots(list);
      }, { passive: true });

      mq.addEventListener('change', function () {
        if (!mq.matches) {
          if (dotsRoot) dotsRoot.classList.remove('is-visible');
        }
      });

      setTimeout(function () {
        if (!mq.matches) return;
        var list = slides();
        if (list.length === 2) {
          /* Une page rouverte peut arriver deja defilee sous le bloc, sans
             qu'aucun evenement de defilement ne se produise : la colonne
             partirait collee alors qu'elle devrait etre remontee. */
          suivreDecollage(list[1].y);
          updateDots(list);
        }
      }, 350);

      /* ═══ QUAND RECALCULER LA RÉSERVE ═══
         Le bloc se remplit toujours APRÈS coup — c'est le JS qui monte ses
         vignettes. Une réserve calculée une fois pour toutes serait celle d'un
         bloc qui n'existait pas encore. On recalcule donc quand le bloc bouge
         vraiment : à chaque changement de la grille, à chaque changement de sa
         taille, au chargement, au redimensionnement.

         Et quand le calage n'a plus lieu d'être — liste incomplète, mode
         téléphone — la réserve s'efface au lieu de garder sa dernière valeur. */
      function recalerReserve() {
        if (!mq.matches) { relacherColonne(); viderReserve(); return; }
        var list = slides();
        if (list.length !== 2) { viderReserve(); return; }
        ensureCenteringRoom(list);
        updateDots(list);
      }

      var minuteurReserve = null;
      function recalerBientot() {
        clearTimeout(minuteurReserve);
        minuteurReserve = setTimeout(recalerReserve, 120);
      }

      var bloc2 = document.getElementById('rv5-bloc-associated');
      var grille = bloc2 && bloc2.querySelector('.rv5-associated-grid');
      if (grille) {
        new MutationObserver(recalerBientot).observe(grille, { childList: true, subtree: true });
        if (typeof ResizeObserver === 'function') {
          /* Le bloc, pas la reserve : la reserve est sa voisine, jamais son
             enfant, donc la redimensionner ne peut pas relancer l'observateur. */
          new ResizeObserver(recalerBientot).observe(bloc2);
        }
      }
      window.addEventListener('load', recalerBientot);
      mq.addEventListener('change', function () { relacherColonne(); recalerBientot(); });
      window.addEventListener('resize', recalerBientot, { passive: true });
    }

    /* ═══════════ « EN SAVOIR PLUS » — SIMPLE, DANS LE BLOC (20/10/2026, soir) ═══════════

       Max, 20/10 vers 21 h, sur la fiche de 19 h 43 : « C'est tellement pire
       qu'avant […] Il faut quelque chose de beaucoup plus simple […] C'est
       cense etre comme avant, centre. Donc on doit avoir notre bloc de
       droite, qui est comme avant. »

       Le bloc de droite ne bouge plus : meme place, meme taille, la colonne
       ne s'elargit pas. Le titre, l'artiste et la reference restent. Format,
       Finition et le panier s'effacent (R2) ; a leur place, dans leur
       rectangle exact, six lignes courtes : le nom du volet et le debut de
       son texte. Aucun texte nouveau : tout vient de la source cachee de la
       section. Au pied, la ou etait le panier, « Retour a l'achat ».

       ORDINATEUR. Le module est cale en absolu sur la colonne, dans le
       rectangle mesure bloc ferme, du bas du cartel au bas de la rangee
       d'achat. Il tient sans defiler.

       TELEPHONE (< 900 px). Le meme contenu, dans le flux, sous l'en-tete du
       bloc, a la place des choix et des boutons.

       21/10 (v4) — Max : « On a perdu l'interet de en savoir plus je trouve
       ça bien pcq c'est simple, mais ça convertit plus du tout ». Ouvert, la
       v3 retirait le panier : on lisait pour se decider, sans pouvoir
       acheter. Desormais le panier reste (la vraie rangee d'achat, avec son
       prix) ; le module ne prend que la place de Format et Finition ; il dit
       « Ce que vous recevez », en quatre lignes concretes ; et, juste
       au-dessus du panier, la date de livraison estimee. « En savoir plus »
       devient « Fermer ». (Formes essayees en captures : la liste de la v3
       remise dans l'ordre des preuves ; une phrase vraie et trois preuves.)

       Chaque ligne n'apparait que si le texte de son volet dit deja la meme
       chose (preuves) : rien n'est promis ici que le volet ne promette. Une
       edition ouverte, dont le volet ne dirait plus « signe et numerote »,
       perdrait d'elle-meme la premiere ligne. */
    var RECU = [
      { slot: 'signature', preuves: [/signé et numéroté à la main|signed and numbered by hand|hand-signed and numbered|firmada y numerada a mano|署名とナンバーを入れ/i], ligne: 'Le tirage, signé et numéroté à la main' },
      { slot: 'certificat', preuves: [/certificat d.authenticité|certificate of authenticity|certificado de autenticidad|作品証明書/i, /cachet de cire|wax seal|sello de lacre|封蝋/i], ligne: 'Son certificat d’authenticité, scellé à la cire' },
      { slot: 'impression', preuves: [/tirage d.archive pigmentaire|archival pigment print|tintas pigmentadas de archivo|アーカイバル顔料プリント/i, /conservation muséale \+200 ans|longevity of 200\+ years|más de 200 años|200年以上/i], ligne: 'Un tirage d’archive pigmentaire, conservation muséale +200 ans' },
      { slot: 'livraison', preuves: [/imprimé et encadré en France|printed and framed in France|impresa y enmarcada en Francia|フランスで印刷・額装/i], ligne: 'Imprimé et encadré en France' }
    ];
    var COCHE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

    /* La date estimee, pres du bouton : le delai vient du texte du volet
       Livraison (« ~14 jours ouvres ») ; rien n'est ecrit ici. Jours ouvres :
       ni samedi, ni dimanche, ni jour ferie en France. Sans delai lisible
       dans le volet, pas de date. */
    function paques(an) {
      var a = an % 19, b = Math.floor(an / 100), c = an % 100, d = Math.floor(b / 4), e = b % 4;
      var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      var x = h + l - 7 * m + 114;
      return new Date(an, Math.floor(x / 31) - 1, (x % 31) + 1, 12);
    }
    function joursFeries(an) {
      var p = paques(an);
      var mobiles = [1, 39, 50].map(function (n) { var j = new Date(p); j.setDate(j.getDate() + n); return (j.getMonth() + 1) + '-' + j.getDate(); });
      return ['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25'].concat(mobiles);
    }
    /* jours : un délai imposé (« au plus tôt », fiche wk-produit-galerie-scroll-droite) ; sans lui, celui du volet */
    function dateEstimee(src, jours) {
      var b = src && body(src);
      var m = b ? (b.textContent || '').match(/(\d+)\s*(?:jours?\s+ouvr|business\s+days|días\s+laborables|営業日)/i) : null;
      if (!m) return '';
      var reste = jours || +m[1];
      if (!reste || reste > 60) return '';
      var j = new Date();
      j.setHours(12, 0, 0, 0);
      var feries = {};
      [j.getFullYear(), j.getFullYear() + 1].forEach(function (an) { joursFeries(an).forEach(function (cle) { feries[an + '-' + cle] = 1; }); });
      while (reste > 0) {
        j.setDate(j.getDate() + 1);
        var jour = j.getDay();
        if (jour === 0 || jour === 6 || feries[j.getFullYear() + '-' + (j.getMonth() + 1) + '-' + j.getDate()]) continue;
        reste--;
      }
      /* Dans la langue de la page, comme la phrase qui la porte (stack_eta). */
      try {
        var d = j.toLocaleDateString(document.documentElement.lang || 'fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
        /* Espagnol : Intl rend « martes, 3 de noviembre » (forme d'en-tête de lettre) ; dans la phrase,
           « el martes 3 de noviembre », sans virgule (27/10, langues-continue-fiche-tirage-horizontal). */
        return /^es/i.test(document.documentElement.lang || '') ? d.replace(/^([^\s,]+), /, '$1 ') : d;
      } catch (err) { return ''; }
    }


    /* ═══ v5 (21/10 au soir) — des parties qu'on ouvre ═══
       Max : « le en savoir plus, bon, ok, il fonctionne, mais je suis pas
       très fan. Il manque encore quelque chose, peut-être de pouvoir ouvrir.
       Certaines choses, je sais pas, mais ça manque de trucs. »
       Ce que l'on veut savoir avant d'acheter, en cinq parties : le papier et
       l'impression, le cadre et le passe-partout, la signature et le
       certificat, la livraison et le retour, l'artiste. Fermee, chaque partie
       dit l'essentiel en quelques mots ; ouverte, deux ou trois phrases. Une
       seule ouverte a la fois : le module garde sa taille.
       Rien n'est ecrit ici qui ne soit deja sur le site : les volets de la
       section, leur table des dimensions (au format choisi), la section de
       l'artiste plus bas sur la page ; pour le retour, la politique publiee
       (/policies/refund-policy). La facon dont la signature est faite ne se
       detaille pas (canon, § 11) : ni « au dos », ni « au crayon » ;
       « a la main, sur le devant du tirage » se dit (Max, 29/10).
       Trois formes, une meme matiere : A, les parties qu'on ouvre (posee) ;
       B, des onglets ; C, la liste « Ce que vous recevez » de la v4, dont
       chaque ligne s'ouvre. « ?esp=b » ou « ?esp=c » dans l'adresse, ou
       data-esp-forme sur la section, rappellent B et C. */
    var FORME = (function () {
      var m = /[?&]esp=([abc])(?:&|$)/i.exec(window.location.search);
      var f = String((m && m[1]) || section.getAttribute('data-esp-forme') || 'a').toLowerCase();
      return (f === 'b' || f === 'c') ? f : 'a';
    })();
    /* Le retour, tel que la politique publiée le dit (/policies/refund-policy) : le délai, l'état du tirage, le
       tirage abîmé à l'arrivée. Deux phrases ne suffisaient pas (Max, 27/10, 18 h 30 : « on avait bossé des phrases
       vraiment super » ; fiche b27-fiche-en-savoir-plus). */
    var RETOUR = ['Vous avez 14 jours après réception pour demander un retour.',
      'Le tirage revient dans l’état où vous l’avez reçu : il peut avoir été accroché, tant qu’il reste en parfait état.',
      'Abîmé à l’arrivée ? Envoyez-nous une photo du colis et du tirage : nous le réimprimons ou nous vous remboursons, à votre choix.'];

    /* Les phrases d'un volet, sans sa table. */
    function phrasesDe(src) {
      var b = src && body(src);
      if (!b) return [];
      var c = b.cloneNode(true);
      Array.prototype.forEach.call(c.querySelectorAll('table'), function (n) { n.parentNode.removeChild(n); });
      Array.prototype.forEach.call(c.querySelectorAll('p, li, br'), function (n) { n.insertAdjacentText('afterend', ' '); });
      var txt = (c.textContent || '').replace(/\s+/g, ' ').trim();
      return (txt.match(/[^.!?。！？]+(?:[.!?。！？]+|$)/g) || []).map(function (p) { return p.trim(); }).filter(Boolean);
    }
    /* Le libellé est dans la langue de la page : « SANS CADRE », « NO FRAME »,
       « SIN MARCO », 「フレームなし」 (variant.frame.none_upper). */
    function sansCadre() {
      var el = document.getElementById('rv5-color-label');
      return /sans|none|no frame|papier|paper|sin marco|フレームなし/i.test(el ? el.textContent : '');
    }
    function mm(v) { return String(v || '').replace(/\s*[×x]\s*/, ' × ') + (/mm/i.test(v) ? '' : ' mm'); }

    /* La matiere des trois formes, relue a chaque ouverture : le format et
       la finition ont pu changer depuis la derniere. */
    function matiere(parSlot) {
      var fmt = selectedFmt();
      var dsrc = parSlot.dimension;
      var table = dsrc && body(dsrc).querySelector('table:not(.bm-dimtable)');
      var dims = table ? parseDimTable(table) : dimData;
      var d = (fmt && dims && dims[fmt]) || null;
      var nu = sansCadre();
      var parties = [];

      /* Le module garde sa taille : chaque partie tient en trois ou quatre
         lignes. On garde l'essentiel de chaque volet. */
      /* Chaque volet en entier, un paragraphe par sujet ; le panneau défile s'il le faut (Max, 27/10, 18 h 30 :
         « j'ai l'impression d'avoir moins d'informations qu'avant » ; fiche b27-fiche-en-savoir-plus). */
      var impression = phrasesDe(parSlot.impression);
      if (impression.length) {
        /* la marge blanche (volet Dimensions) dit le papier ; sans cadre, elle dit le cadre (plus bas) */
        var papierFmt = nu ? [] : phrasesDe(dsrc).slice(0, 1);
        if (d && d.Papier && d.Image) papierFmt.push(tfill('esp_dims', 'En {fmt} : papier {papier}, image {image}.', { fmt: fmt, papier: mm(d.Papier), image: mm(d.Image) }));
        parties.push({ id: 'papier', nom: t('esp_papier', 'Papier & impression'), court: t('esp_papier_court', 'Papier'),
          resume: /tirage d.archive pigmentaire|archival pigment print|tintas pigmentadas de archivo|アーカイバル顔料プリント/i.test(impression[0]) ? t('esp_papier_resume', 'Archive pigmentaire') : '',
          lignes: impression.concat(papierFmt), paras: [impression, papierFmt],
          dims: (d && d.Papier && d.Image) ? { fmt: fmt, papier: d.Papier, image: d.Image } : null });
      }

      var encadrement = phrasesDe(parSlot.encadrement);
      var marge = phrasesDe(dsrc).slice(0, 1);
      if (encadrement.length || marge.length) {
        var cadre = (nu && marge.length) ? marge.slice() : encadrement.slice();
        if (!nu && d && d['Ouv. PP']) cadre.push(tfill('esp_ouverture', 'Ouverture du passe-partout en {fmt} : {ouv}.', { fmt: fmt, ouv: mm(d['Ouv. PP']) }));
        var resumeCadre = nu ? (marge.length ? t('esp_cadre_resume_nu', 'Marge blanche') : '')
          : (/sans acide|acid-free|sin ácido|無酸性/i.test(encadrement.join(' ')) && /45/.test(encadrement.join(' ')) ? t('esp_cadre_resume', 'Sans acide, biseau 45°') : '');
        parties.push({ id: 'cadre', nom: t('esp_cadre', 'Cadre & passe-partout'), court: t('esp_cadre_court', 'Cadre'), resume: resumeCadre, lignes: cadre,
          nu: nu, ouv: (!nu && d && d['Ouv. PP']) ? { fmt: fmt, ouv: d['Ouv. PP'] } : null });
      }

      /* Canon, § 11 : la signature est la ; la facon, non. 29/10 (Max, argon-s-lot-textes) : « signé et numéroté
         à la main, sur le devant du tirage » se dit ; « à la main » n'est plus retiré. Jamais « au dos ». */
      var signature = phrasesDe(parSlot.signature)
        .filter(function (p) { return !/\bau dos\b|\bcrayon|\bon the back\b|\bpencil\b|al dorso|lápiz|裏面|鉛筆/i.test(p); });
      var certificat = phrasesDe(parSlot.certificat);
      if (signature.length || certificat.length) {
        var preuves = [];
        var tout = signature.concat(certificat).join(' ');
        if (/signé|signed|firmad|署名/i.test(tout)) preuves.push(t('esp_signe', 'Signé'));
        if (/numéroté|numbered|numerad|ナンバーを入れ|ナンバー入り/i.test(tout)) preuves.push(t('esp_numerote', 'numéroté'));
        if (/NFC/.test(tout)) preuves.push('NFC');
        parties.push({ id: 'signature', nom: t('esp_signature', 'Signature & certificat'), court: t('esp_signature_court', 'Signature'),
          resume: preuves.join(' · '), lignes: signature.concat(certificat), paras: [signature, certificat] });
      }

      /* « Imprimé et encadré en France » : dit par la ligne de la forme C ;
         sans cadre, rien n'est encadre (relecture v4, remarque 1). L'emballage
         (a plat, en tube) reste dans le volet : la partie tient a 1 440 × 900. */
      /* 27/10 (b27-fiche-en-savoir-plus) : le volet Livraison en entier, emballage compris, puis le retour en second
         paragraphe ; sans cadre, la phrase « encadré » devient « Imprimé en France ». */
      var jaL = /^ja/i.test(document.documentElement.lang || '');
      var livraison = phrasesDe(parSlot.livraison).map(function (p) {
        return (nu && /encadré en France|framed in France|enmarcada en Francia|フランスで印刷・額装/i.test(p)) ? t('esp_recu_livraison_nu', 'Imprimé en France') + (jaL ? '。' : '.') : p;
      });
      /* une langue qui n'a pas encore les phrases 2 et 3 (ja, es) les tait au lieu de les dire en français */
      var frL = /^fr/i.test(document.documentElement.lang || 'fr');
      /* 29/10 (argon-s-lot-textes, point 8) : l'emballage des encadrés, comme la politique publiée (« Tirages encadrés :
         emballage adapté, sécurisé et renforcé »), juste après « tubes renforcés. » ; rien sans cadre. Comme RETOUR : une
         langue sans la phrase la tait. */
      var embCadre = nu ? '' : (frL ? t('esp_livraison_cadre', 'Encadrés : emballage renforcé, adapté au cadre.') : (I18N.esp_livraison_cadre || ''));
      if (embCadre) {
        var iTube = -1;
        livraison.forEach(function (p, i) { if (/tubes renforcés|reinforced tubes|tubos reforzados|補強した筒/i.test(p)) iTube = i; });
        livraison.splice(iTube >= 0 ? iTube + 1 : livraison.length, 0, embCadre);
      }
      var retours = RETOUR.map(function (l, i) { return (i === 0 || frL) ? t('esp_retour_' + (i + 1), l) : (I18N['esp_retour_' + (i + 1)] || ''); }).filter(Boolean);
      parties.push({ id: 'livraison', nom: t('esp_livraison', 'Livraison & retour'), court: t('esp_livraison_court', 'Livraison'),
        resume: t('esp_livraison_resume', 'Retour sous 14 jours'),
        lignes: livraison.concat(retours), paras: [livraison, retours],
        lien: { href: '/policies/refund-policy', texte: t('esp_retour_lien', 'Retours et remboursements') } });

      /* L'artiste : ce que dit sa section, plus bas sur la page. */
      var nomA = document.querySelector('.baa3__nom');
      if (nomA && nomA.textContent.trim()) {
        var bio = document.querySelector('.baa3__bio');
        /* 。！？ comme dans phrasesDe : sans eux, la bio japonaise passait entière dans « En savoir plus », et le
           compte prenait un point latin (27/10, langues-continue-fiche-tirage-vertical). */
        var jaA = /^ja/i.test(document.documentElement.lang || '');
        var phrasesBio = bio ? ((bio.textContent || '').replace(/\s+/g, ' ').trim().match(/[^.!?。！？]+(?:[.!?。！？]+|$)/g) || []) : [];
        var compte = document.querySelector('.baa3__compte');
        var lienA = document.querySelector('.baa3__lien') || nomA.querySelector('a');
        var photo = document.querySelector('.baa3__photo img');
        var lignesA = phrasesBio.slice(0, 2).map(function (p) { return p.trim(); });
        if (compte && compte.textContent.trim()) lignesA.push(compte.textContent.trim().replace(/^./, function (c) { return c.toUpperCase(); }) + (jaA ? '。' : '.'));
        parties.push({ id: 'artiste', nom: t('esp_artiste', 'L’artiste'), court: t('esp_artiste_court', 'Artiste'),
          resume: nomA.textContent.trim(), lignes: lignesA,
          lien: lienA && lienA.getAttribute('href') ? { href: lienA.getAttribute('href'), texte: t('esp_artiste_lien', 'Voir l’artiste') } : null,
          photo: photo ? (photo.currentSrc || photo.getAttribute('src')) : '' });
      }

      /* C : les lignes de la v4, chacune ouvre sa partie. */
      var parId = {};
      parties.forEach(function (p) { parId[p.id] = p; });
      var recus = [];
      RECU.forEach(function (r) {
        var src = parSlot[r.slot];
        var texte = src ? (body(src).textContent || '').replace(/\s+/g, ' ') : '';
        if (!texte || !r.preuves.every(function (p) { return p.test(texte); })) return;
        var ligne = t('stack_recu_' + r.slot, r.ligne);
        if (r.slot === 'livraison' && nu) ligne = t('esp_recu_livraison_nu', 'Imprimé en France');
        var lignes = r.slot === 'signature' ? signature : r.slot === 'certificat' ? certificat
          : r.slot === 'impression' ? (parId.papier || {}).lignes : (parId.livraison || {}).lignes;
        recus.push({ id: 'c-' + r.slot, nom: ligne, lignes: lignes || [], lien: r.slot === 'livraison' ? parId.livraison.lien : null });
      });
      if (!nu && parId.cadre && parId.cadre.resume) recus.push({ id: 'c-cadre', nom: t('esp_recu_cadre', 'Un passe-partout sans acide, biseau à 45°'), lignes: parId.cadre.lignes });
      if (parId.artiste) recus.push({ id: 'c-artiste', nom: tfill('esp_recu_artiste', 'Une photographie de {nom}', { nom: parId.artiste.resume }), lignes: parId.artiste.lignes, lien: parId.artiste.lien, photo: parId.artiste.photo });

      return { parties: parties, recus: recus };
    }

    function corpsDe(it) {
      var c = document.createElement('div');
      c.className = 'bmv5__corps';
      if (it.photo) {
        var f = document.createElement('span');
        f.className = 'bmv5__photo';
        var im = document.createElement('img');
        im.src = it.photo; im.alt = ''; im.loading = 'lazy';
        f.appendChild(im);
        c.appendChild(f);
      }
      var txt = document.createElement('div');
      txt.className = 'bmv5__texte';
      /* Un paragraphe par sujet (la livraison, puis le retour) plutôt qu'un seul bloc (Max, 27/10, 18 h 30 : « en
         termes d'écriture, le bordel » ; fiche b27-fiche-en-savoir-plus). */
      var sep = /^ja/.test(document.documentElement.lang) ? '' : ' ';
      (it.paras || (it.lignes && it.lignes.length ? [it.lignes] : [])).forEach(function (l) {
        if (!l || !l.length) return;
        var p = document.createElement('p');
        p.textContent = l.join(sep);
        txt.appendChild(p);
      });
      if (it.lien) {
        var a = document.createElement('a');
        a.className = 'bmv5__lien';
        a.href = it.lien.href;
        a.innerHTML = '<span></span>' + A_R;
        a.querySelector('span').textContent = it.lien.texte;
        txt.appendChild(a);
      }
      c.appendChild(txt);
      return c;
    }

    /* A et C : une partie ouverte a la fois. */
    function accordeon(items, coche) {
      var root = document.createElement('div');
      root.className = 'bmv5 ' + (coche ? 'bmv5--c' : 'bmv5--a');
      items.forEach(function (it) {
        var part = document.createElement('div');
        part.className = 'bmv5__part';
        part.setAttribute('data-part', it.id);
        var tete = document.createElement('button');
        tete.type = 'button';
        tete.className = 'bmv5__tete';
        tete.id = 'bmv5-t-' + it.id;
        tete.setAttribute('aria-expanded', 'false');
        tete.setAttribute('aria-controls', 'bmv5-p-' + it.id);
        tete.innerHTML = (coche ? COCHE : '') + '<span class="bmv5__nom"></span>' +
          (it.resume ? '<span class="bmv5__resume"></span>' : '') + '<span class="bmv5__plus" aria-hidden="true"></span>';
        tete.querySelector('.bmv5__nom').textContent = it.nom;
        if (it.resume) tete.querySelector('.bmv5__resume').textContent = it.resume;
        var corps = corpsDe(it);
        corps.id = 'bmv5-p-' + it.id;
        corps.setAttribute('role', 'region');
        corps.setAttribute('aria-labelledby', tete.id);
        corps.hidden = true;
        part.appendChild(tete);
        part.appendChild(corps);
        root.appendChild(part);
      });
      root.addEventListener('click', function (e) {
        var tete = e.target && e.target.closest && e.target.closest('.bmv5__tete');
        if (!tete || !root.contains(tete)) return;
        var ouvrir = tete.getAttribute('aria-expanded') !== 'true';
        Array.prototype.forEach.call(root.querySelectorAll('.bmv5__part'), function (p) {
          var on = ouvrir && p === tete.parentNode;
          p.classList.toggle('is-open', on);
          p.querySelector('.bmv5__tete').setAttribute('aria-expanded', on ? 'true' : 'false');
          p.querySelector('.bmv5__corps').hidden = !on;
        });
        root.classList.toggle('has-open', ouvrir);
        /* Ecran bas : si la partie ouverte depasse, la zone la montre
           entiere, sans bouger la page. */
        var z = root.parentNode;
        if (ouvrir && z && z.scrollHeight > z.clientHeight + 1) {
          var zr = z.getBoundingClientRect();
          var pr = tete.parentNode.getBoundingClientRect();
          if (pr.bottom > zr.bottom) z.scrollTop += Math.min(pr.bottom - zr.bottom, pr.top - zr.top);
          else if (pr.top < zr.top) z.scrollTop -= zr.top - pr.top;
        } else if (ouvrir && !tete.hasAttribute('data-sans-defiler') && root.closest('.bmk--flux')) {
          /* v6, dans la page : une partie qui s'ouvre sous le bas de l'ecran
             monte juste assez pour se lire en entier, sans passer sous
             l'en-tete du site. */
          var css = window.getComputedStyle(document.documentElement);
          var entete = (parseFloat(css.getPropertyValue('--announcement-bar-height')) || 0) +
            (parseFloat(css.getPropertyValue('--header-height')) || 0);
          var p = tete.parentNode.getBoundingClientRect();
          var d = Math.min(p.bottom - (window.innerHeight - 16), p.top - entete - 12);
          if (d > 0) { try { window.scrollBy({ top: d, behavior: 'smooth' }); } catch (err) { window.scrollBy(0, d); } }
        }
      });
      return root;
    }

    /* B : des onglets, une partie visible. */
    function onglets(items) {
      var root = document.createElement('div');
      root.className = 'bmv5 bmv5--b';
      var barre = document.createElement('div');
      barre.className = 'bmv5__onglets';
      barre.setAttribute('role', 'tablist');
      root.appendChild(barre);
      items.forEach(function (it, i) {
        var o = document.createElement('button');
        o.type = 'button';
        o.className = 'bmv5__onglet';
        o.id = 'bmv5-o-' + it.id;
        o.setAttribute('role', 'tab');
        o.setAttribute('aria-controls', 'bmv5-q-' + it.id);
        o.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        o.tabIndex = i === 0 ? 0 : -1;
        o.textContent = it.court;
        barre.appendChild(o);
        var c = corpsDe(it);
        c.id = 'bmv5-q-' + it.id;
        c.setAttribute('role', 'tabpanel');
        c.setAttribute('aria-labelledby', o.id);
        c.hidden = i !== 0;
        var accroche = document.createElement('p');
        accroche.className = 'bmv5__accroche';
        accroche.textContent = it.resume ? it.nom + ' · ' + it.resume : it.nom;
        (c.querySelector('.bmv5__texte') || c).insertBefore(accroche, (c.querySelector('.bmv5__texte') || c).firstChild);
        root.appendChild(c);
      });
      function choisir(o) {
        Array.prototype.forEach.call(barre.children, function (x) {
          var on = x === o;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var p = root.querySelector('[id="' + x.getAttribute('aria-controls') + '"]');
          if (p) p.hidden = !on;
        });
      }
      barre.addEventListener('click', function (e) {
        var o = e.target && e.target.closest && e.target.closest('.bmv5__onglet');
        if (o) choisir(o);
      });
      barre.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var tous = Array.prototype.slice.call(barre.children);
        var i = tous.indexOf(document.activeElement);
        if (i < 0) return;
        var o = tous[(i + (e.key === 'ArrowRight' ? 1 : tous.length - 1)) % tous.length];
        choisir(o);
        o.focus();
        e.preventDefault();
      });
      return root;
    }

    /* Le module courant : reconstruit a chaque bascule de palier, et
       DETRUIT proprement avant — ses ecouteurs sur document/window y compris. */
    var moduleCourant = null;

    function buildPostale() {
      var parSlot = {};
      srcs.forEach(function (s) {
        var slot = (s.getAttribute('data-slot') || '').trim();
        if (slot && !parSlot[slot]) parSlot[slot] = s;
      });

      var colonne = document.querySelector('.bisou-s1-wrapper');

      /* v6 (22/10) — Max : « ensavoir plus l'idées est bien mais c'est
         toujours pas bon genre c'est bugé on vois un slider moche ». Ouvert,
         le module ne prend plus la place du format et de la finition, et ne
         vit plus dans un rectangle a hauteur fixe qui defile : il s'ouvre
         dans le bloc, sous la rangee d'achat, et la page grandit avec lui.
         Le format, la finition et le panier restent visibles et actifs.
         « ?esp6=dessus » le pose au-dessus de la rangee d'achat (l'autre
         direction, montree en captures). Sans rangee d'achat, l'ancien
         module en absolu. */
      /* v7 (22/10, 21 h) — Max : « en savoir plus, c'est full buggé. Je veux
         surtout pas de slider sur les côtés » ; le bloc de droite reste
         centre, « on a tout le temps des éléments en dessous là, qui se
         rajoutent. Non, j'en veux pas ». Ouvert, le module ne touche plus au
         bloc : il s'ouvre par-dessus le carre des images (telephone : plein
         ecran), qu'on ferme d'une croix, d'Echap ou d'un toucher a cote ; le
         bloc de droite reste entier, visible et actif. Une partie ouverte a
         la fois : tout tient, sans hauteur fixe ni zone qui defile.
         « ?esp7=fenetre » l'ouvre dans une fenetre centree sur un voile
         (l'autre direction, montree en captures) ; « ?esp7=v6 » rappelle la
         v6, dans la page. */
      var V6 = /[?&]esp7=v6(?:&|$)/i.test(window.location.search);
      var CARRE = !/[?&]esp7=fenetre(?:&|$)/i.test(window.location.search);
      var FEN = !V6;

      var bloc1 = colonne && colonne.querySelector('.bisou-s1-sticky');
      var rangeeAchat = bloc1 && bloc1.querySelector(':scope > .bisou-buy-row');
      var FLUX = !!rangeeAchat && !FEN;
      var DESSUS = /[?&]esp6=dessus(?:&|$)/i.test(window.location.search);

      var pile = document.createElement('div');
      pile.className = 'bmk bmk--v3';
      pile.setAttribute('hidden', '');
      pile.setAttribute('role', 'region');
      pile.setAttribute('aria-label', t('stack_open', 'En savoir plus'));

      /* v7 : un voile, un panneau, une croix (un toucher a cote ferme :
         aCote, plus bas). */
      var panneau = pile, croix = null;
      if (FEN) {
        pile.classList.add('bmk--fen');
        pile.setAttribute('role', 'dialog');
        pile.setAttribute('aria-modal', 'true');
        var voile = document.createElement('div');
        voile.className = 'bmk7__voile';
        pile.appendChild(voile);
        panneau = document.createElement('div');
        panneau.className = 'bmk7__panneau';
        croix = document.createElement('button');
        croix.type = 'button';
        croix.className = 'bmk7__x';
        croix.setAttribute('aria-label', t('stack_close', 'Fermer'));
        croix.innerHTML = X;
        croix.addEventListener('click', function () { refermer(); });
        panneau.appendChild(croix);
        pile.appendChild(panneau);
      }

      var inner = document.createElement('div');
      inner.className = 'bmk__inner';

      /* Le titre, comme « Format » et « Finition » qu'il remplace. */
      var titre = document.createElement('h2');
      titre.className = 'rv5-flbl bmv3__t';
      titre.textContent = FORME === 'c' ? t('stack_recu', 'Ce que vous recevez') : t('esp_titre', 'Avant d’acheter');
      /* L'artiste d'abord, avec sa photo de profil à droite, comme dans le bloc de droite (Max, 23/10, 14 h : « pour
         l'artiste on peut le mettre comme sur le bloc de droite avec sa photo de profil à droite » ; au téléphone :
         « l'artiste passe au-dessus de Avant d'acheter » ; fiche wk-produit-galerie-scroll-droite). Forme A seulement :
         sa partie quitte alors la liste. */
      var artisteA = FORME === 'a' ? matiere(parSlot).parties.filter(function (p) { return p.id === 'artiste'; })[0] : null;
      if (artisteA) {
        var carteA = document.createElement('div');
        carteA.className = 'bmv5-artiste';
        carteA.innerHTML = '<div class="bmv5-artiste__txt"><p class="bmv5-artiste__qui"></p><p class="bmv5-artiste__nom"></p></div>';
        carteA.querySelector('.bmv5-artiste__qui').textContent = artisteA.nom;
        carteA.querySelector('.bmv5-artiste__nom').textContent = artisteA.resume;
        var txtA = carteA.querySelector('.bmv5-artiste__txt');
        if (artisteA.lignes && artisteA.lignes.length) {
          var bioA = document.createElement('p');
          bioA.className = 'bmv5-artiste__bio';
          bioA.textContent = artisteA.lignes.join(/^ja/.test(document.documentElement.lang) ? '' : ' ');
          txtA.appendChild(bioA);
        }
        if (artisteA.lien) {
          var lA = document.createElement('a');
          lA.className = 'bmv5__lien';
          lA.href = artisteA.lien.href;
          lA.innerHTML = '<span></span>' + A_R;
          lA.querySelector('span').textContent = artisteA.lien.texte;
          txtA.appendChild(lA);
        }
        if (artisteA.photo) {
          var phA = document.createElement('span');
          phA.className = 'bmv5-artiste__photo';
          var imA = document.createElement('img');
          imA.src = artisteA.photo; imA.alt = ''; imA.loading = 'lazy';
          phA.appendChild(imA);
          carteA.appendChild(phA);
        }
      }
      /* La carte du haut cède la place au bloc qu'on ouvre (Max, 26/10, 16 h : « quand on clique sur un des blocs avant
         d'acheter, la carte du haut L'artiste pourrait révéler une image ou une animation […] ça doit rassurer le
         client » ; fiche a26-fiche-en-savoir-plus). Un dessin par bloc, fait de ce que le bloc dit déjà : le papier et
         l'image à l'échelle du format choisi, le cadre et l'ouverture du passe-partout, le certificat et son cachet, le
         colis et le retour. Des dessins, jamais une photo inventée. L'ouverture automatique de la première partie ne
         compte pas : l'artiste reste en tête tant qu'on n'a rien cliqué. */
      var haut = document.createElement('div');
      haut.className = 'bmv8-haut' + (carteA ? '' : ' bmv8-haut--seul');
      if (carteA) haut.appendChild(carteA);
      var vis = document.createElement('div');
      vis.className = 'bmv8-vis';
      haut.appendChild(vis);
      inner.appendChild(haut);
      inner.appendChild(titre);

      /* v5 : les parties qu'on ouvre, refaites a chaque ouverture (format,
         finition). */
      var zone = document.createElement('div');
      zone.className = 'bmv5__zone';
      zone.setAttribute('data-forme', FORME);
      inner.appendChild(zone);
      /* `garder` : refait sur place, la partie (ou l'onglet) ouverte le
         reste — le format ou la finition viennent de changer, module ouvert. */
      function remplir(garder) {
        var ouverte = garder && zone.querySelector('.bmv5__part.is-open');
        var idOuverte = ouverte && ouverte.getAttribute('data-part');
        var onglet = garder && zone.querySelector('.bmv5__onglet[aria-selected="true"]');
        var idOnglet = onglet && onglet.id;
        var m = matiere(parSlot);
        zone.innerHTML = '';
        var partiesA = artisteA ? m.parties.filter(function (p) { return p.id !== 'artiste'; }) : m.parties;
        zone.appendChild(FORME === 'b' ? onglets(m.parties) : accordeon(FORME === 'c' ? m.recus : partiesA, FORME === 'c'));
        /* au premier remplissage, la première partie s'ouvre (Max, 23/10 : « un déjà ouvert qui laisse voir tous les
           autres » ; fiche wk-produit-galerie-scroll-droite) ; refait sur place, on garde ce que le visiteur a choisi.
           À l'ordinateur, tout reste fermé : le volet tient sans défiler (Max, 28/10, 18 h 45 : « Le fait de
           scroller, c'est interdit » ; fiche c29-en-savoir-plus-sans-defiler) */
        var r = idOuverte ? zone.querySelector('[data-part="' + idOuverte + '"] .bmv5__tete')
          : idOnglet ? zone.querySelector('[id="' + idOnglet + '"]')
          : (!garder && FORME !== 'b' && !mq.matches) ? zone.querySelector('.bmv5__part .bmv5__tete') : null;
        if (r) { r.setAttribute('data-sans-defiler', ''); r.click(); r.removeAttribute('data-sans-defiler'); }
        dernieres = m.parties;
        montrer(garder ? haut.getAttribute('data-vis') : '');
        etatAtc();
      }

      var dernieres = [];
      var NS = 'http://www.w3.org/2000/svg';
      function el(nom, attrs, parent) {
        var n = document.createElementNS(NS, nom);
        for (var k in attrs) { if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]); }
        if (parent) parent.appendChild(n);
        return n;
      }
      function nombres(v) { return String(v || '').match(/\d+(?:[.,]\d+)?/g) || []; }
      /* La photo du tirage : son image « sans cadre » (…_Sans.png, la photo au centre d'un fond transparent), au
         format choisi si la page l'a ; sinon l'image que la boutique donne aux partages. */
      /* Le début du nom des images de ce tirage (« La_trace_des_Montagnes_ »), tiré de son image de partage : le menu
         et les rangées de la page portent les images d'autres tirages. */
      function prefixeTirage() {
        var m = document.querySelector('meta[property="og:image"]');
        var f = ((m && m.getAttribute('content')) || '').split('?')[0].split('/').pop();
        var p = f.replace(/_[^_]+_(Sans|Cadre_[^_.]+)\.\w+$/i, '_');
        return p !== f ? p : '';
      }
      function imageTirage(fmt) {
        var pre = prefixeTirage();
        var vues = [];
        Array.prototype.forEach.call(document.querySelectorAll('img, source'), function (n) {
          [n.currentSrc, n.getAttribute('src'), n.getAttribute('data-src'), (n.getAttribute('srcset') || '').split(/\s/)[0]].forEach(function (s) {
            if (s && pre && s.indexOf(pre) >= 0 && /_Sans\.(png|jpe?g|webp)/i.test(s)) vues.push(s);
          });
        });
        var re = fmt ? new RegExp('_' + String(fmt).replace(/[^\w]/g, '') + '_Sans\\.', 'i') : null;
        var s = (re && vues.filter(function (v) { return re.test(v); })[0]) || vues[0] || '';
        var sans = !!s;
        if (!s) {
          var m = document.querySelector('meta[property="og:image:secure_url"]') || document.querySelector('meta[property="og:image"]');
          s = (m && m.getAttribute('content')) || '';
        }
        if (!s) return null;
        s = s.replace(/^\/\//, 'https://').replace(/^http:/, 'https:').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
        return { url: s + (s.indexOf('?') < 0 ? '?' : '&') + 'width=600', sans: sans };
      }
      var nClip = 0;
      /* La photo dans une fenêtre : l'image « sans cadre » agrandie jusqu'à ce que la photo la remplisse. */
      function photo(svg, x, y, w, h, fmt) {
        var im = imageTirage(fmt);
        if (!im) { el('rect', { x: x, y: y, width: w, height: h, 'class': 'bmv8-aplat' }, svg); return; }
        var id = 'bmv8c' + (++nClip) + Math.random().toString(36).slice(2, 6);
        var cp = el('clipPath', { id: id }, el('defs', {}, svg));
        el('rect', { x: x, y: y, width: w, height: h }, cp);
        var z = im.sans ? 1.78 : 1;
        el('image', { href: im.url, x: x - w * (z - 1) / 2, y: y - h * (z - 1) / 2, width: w * z, height: h * z,
          preserveAspectRatio: 'xMidYMid slice', 'clip-path': 'url(#' + id + ')', 'class': 'bmv8-img' }, svg);
      }
      /* Le sens du tirage : la table des dimensions donne toujours le petit côté d'abord ; une image chargée du
         tirage (sans cadre ou encadré) dit s'il est en largeur. Rien de chargé : null, la table telle quelle. */
      function paysage() {
        var r = null, pre = prefixeTirage();
        if (!pre) return r;
        Array.prototype.some.call(document.querySelectorAll('img'), function (n) {
          var s = n.currentSrc || n.src || '';
          if (s.indexOf(pre) >= 0 && /_(Sans|Cadre_\w+)\.(png|jpe?g|webp)/i.test(s) && n.naturalWidth) { r = n.naturalWidth > n.naturalHeight; return true; }
          return false;
        });
        return r;
      }
      function dimsPapier() {
        var p = dernieres.filter(function (x) { return x.id === 'papier'; })[0];
        return p && p.dims;
      }
      /* Un trait qui se dessine (pathLength 1 : la même vitesse pour tous). */
      function trait(nom, attrs, parent) {
        attrs.pathLength = '1';
        attrs['class'] = 'bmv8-trait' + (attrs['class'] ? ' ' + attrs['class'] : '');
        return el(nom, attrs, parent);
      }
      function dessin(p) {
        var svg = el('svg', { viewBox: '0 0 200 140', 'aria-hidden': 'true', focusable: 'false' });
        var dp = dimsPapier();
        var fmt = dp && dp.fmt;
        if (p.id === 'papier') {
          /* Le papier et l'image à l'échelle du format choisi ; sans mesure, une feuille. */
          var np = nombres(p.dims && p.dims.papier), ni = nombres(p.dims && p.dims.image);
          var pw = +String(np[0] || 297).replace(',', '.'), ph = +String(np[1] || 420).replace(',', '.');
          var iw = +String(ni[0] || pw * 0.86).replace(',', '.'), ih = +String(ni[1] || ph * 0.86).replace(',', '.');
          var sens = paysage(), x;
          if (sens !== null && (pw > ph) !== sens) { x = pw; pw = ph; ph = x; }
          if (pw > ph !== iw > ih) { x = iw; iw = ih; ih = x; }
          var k = Math.min(150 / pw, 120 / ph), W = pw * k, H = ph * k, X = (200 - W) / 2, Y = (140 - H) / 2;
          el('rect', { x: X + 3, y: Y + 4, width: W, height: H, 'class': 'bmv8-ombre' }, svg);
          el('rect', { x: X, y: Y, width: W, height: H, 'class': 'bmv8-feuille' }, svg);
          var w2 = iw * k, h2 = ih * k, x2 = X + (W - w2) / 2, y2 = Y + (H - h2) / 2;
          photo(svg, x2, y2, w2, h2, fmt);
          trait('rect', { x: X, y: Y, width: W, height: H }, svg);
          trait('path', { d: 'M' + (X - 8) + ' ' + Y + 'v' + H + 'M' + (X - 11) + ' ' + Y + 'h6M' + (X - 11) + ' ' + (Y + H) + 'h6', 'class': 'bmv8-cote' }, svg);
          trait('path', { d: 'M' + X + ' ' + (Y + H + 8) + 'h' + W + 'M' + X + ' ' + (Y + H + 5) + 'v6M' + (X + W) + ' ' + (Y + H + 5) + 'v6', 'class': 'bmv8-cote' }, svg);
        } else if (p.id === 'cadre') {
          /* De face : la baguette, le passe-partout, son biseau, le tirage. Sans cadre : la marge blanche. */
          var np2 = nombres(dp && dp.papier), sens2 = paysage();
          var large = sens2 !== null ? sens2 : (np2.length > 1 && +String(np2[0]).replace(',', '.') > +String(np2[1]).replace(',', '.'));
          var cw = large ? 160 : 104, chh = large ? 120 : 128, cx = (200 - cw) / 2, cy = (140 - chh) / 2, b = p.nu ? 0 : 9, m2 = p.nu ? 10 : 14;
          el('rect', { x: cx + 3, y: cy + 4, width: cw, height: chh, 'class': 'bmv8-ombre' }, svg);
          if (b) el('rect', { x: cx, y: cy, width: cw, height: chh, 'class': 'bmv8-baguette' }, svg);
          el('rect', { x: cx + b, y: cy + b, width: cw - 2 * b, height: chh - 2 * b, 'class': 'bmv8-feuille' }, svg);
          var ox = cx + b + m2, oy = cy + b + m2, ow = cw - 2 * (b + m2), oh = chh - 2 * (b + m2);
          photo(svg, ox, oy, ow, oh, fmt);
          if (!p.nu) {
            /* le biseau à 45° : un liseré clair autour de l'ouverture, ses quatre coins tracés */
            trait('path', { d: 'M' + (ox - 3) + ' ' + (oy - 3) + 'l3 3M' + (ox + ow + 3) + ' ' + (oy - 3) + 'l-3 3M' + (ox - 3) + ' ' + (oy + oh + 3) + 'l3 -3M' + (ox + ow + 3) + ' ' + (oy + oh + 3) + 'l-3 -3', 'class': 'bmv8-biseau' }, svg);
            trait('rect', { x: ox - 3, y: oy - 3, width: ow + 6, height: oh + 6, 'class': 'bmv8-biseau' }, svg);
            trait('rect', { x: cx, y: cy, width: cw, height: chh }, svg);
            trait('rect', { x: cx + b, y: cy + b, width: cw - 2 * b, height: chh - 2 * b, 'class': 'bmv8-fin' }, svg);
          } else {
            trait('rect', { x: cx, y: cy, width: cw, height: chh }, svg);
          }
        } else if (p.id === 'signature') {
          /* Le certificat : quelques lignes, une signature qui s'écrit, le cachet de cire. */
          el('rect', { x: 43, y: 12, width: 120, height: 118, 'class': 'bmv8-ombre' }, svg);
          el('rect', { x: 40, y: 8, width: 120, height: 118, 'class': 'bmv8-feuille' }, svg);
          trait('rect', { x: 40, y: 8, width: 120, height: 118 }, svg);
          trait('path', { d: 'M58 30h84M58 42h60M58 54h72M58 66h48', 'class': 'bmv8-fin' }, svg);
          trait('path', { d: 'M58 98c6-14 10-16 12-8s-2 14 4 6 8-18 12-10 0 14 6 8 6-10 10-6 4 6 10 2', 'class': 'bmv8-signe' }, svg);
          el('circle', { cx: 132, cy: 102, r: 14, 'class': 'bmv8-cire' }, svg);
          trait('circle', { cx: 132, cy: 102, r: 9, 'class': 'bmv8-cire-trait' }, svg);
        } else if (p.id === 'livraison') {
          /* Le colis qui part, et la flèche du retour. */
          el('path', { d: 'M40 58l46-18 46 18v48l-46 18-46-18z', 'class': 'bmv8-carton' }, svg);
          trait('path', { d: 'M40 58l46 18 46-18M86 76v48M40 58v48l46 18 46-18V58L86 40z' }, svg);
          trait('path', { d: 'M63 49l46 18v12', 'class': 'bmv8-fin' }, svg);
          trait('path', { d: 'M146 52c22 6 30 30 14 50', 'class': 'bmv8-route' }, svg);
          trait('path', { d: 'M164 96l-4 7-7-3', 'class': 'bmv8-route' }, svg);
        } else {
          return null;
        }
        return svg;
      }
      function legende(p) {
        if (p.id === 'papier' && p.dims) return tfill('esp_dims', 'En {fmt} : papier {papier}, image {image}.', { fmt: p.dims.fmt, papier: mm(p.dims.papier), image: mm(p.dims.image) });
        if (p.id === 'cadre' && p.ouv) return tfill('esp_ouverture', 'Ouverture du passe-partout en {fmt} : {ouv}.', { fmt: p.ouv.fmt, ouv: mm(p.ouv.ouv) });
        return '';
      }
      function montrer(id) {
        var p = id ? dernieres.filter(function (x) { return x.id === id; })[0] : null;
        var svg = p && dessin(p);
        if (!svg) { haut.classList.remove('is-vis'); haut.removeAttribute('data-vis'); return; }
        var fig = document.createElement('figure');
        fig.className = 'bmv8-fig bmv8-fig--' + p.id;
        fig.appendChild(svg);
        var cap = document.createElement('figcaption');
        cap.innerHTML = '<span class="bmv8-fig__qui"></span><span class="bmv8-fig__quoi"></span>';
        cap.querySelector('.bmv8-fig__qui').textContent = p.nom;
        cap.querySelector('.bmv8-fig__quoi').textContent = p.resume || '';
        var l = legende(p);
        if (l) {
          var s = document.createElement('span');
          s.className = 'bmv8-fig__mesure';
          s.textContent = l;
          cap.appendChild(s);
        }
        fig.appendChild(cap);
        vis.innerHTML = '';
        vis.appendChild(fig);
        haut.setAttribute('data-vis', id);
        haut.classList.add('is-vis');
      }
      zone.addEventListener('click', function (e) {
        var tete = e.target && e.target.closest && e.target.closest('.bmv5__tete');
        if (!tete || tete.hasAttribute('data-sans-defiler')) return;
        var ouverte = zone.querySelector('.bmv5__part.is-open');
        montrer(ouverte ? ouverte.getAttribute('data-part') : '');
      });

      /* Le bouton de la cellule Livraison suit le vrai bouton du panier (épuisé, variante absente). */
      var atcE = null;
      function vraiAtc() {
        return document.querySelector('.bisou-atc-cell button[name="add"]') ||
          (colonne && colonne.querySelector('form[action*="/cart/add"] button[name="add"]'));
      }
      function etatAtc() {
        if (!atcE) return;
        var v = vraiAtc();
        var off = !v || v.disabled || v.getAttribute('aria-disabled') === 'true';
        atcE.disabled = off;
        var lib = off && v ? (v.textContent || '').replace(/\s+/g, ' ').trim() : '';
        atcE.querySelector('span').textContent = lib || t('stack_atc', 'Ajouter au panier');
      }
      remplir();

      /* v4 : plus de « Retour a l'achat » — le panier reste. Au pied du
         module, juste au-dessus de lui, la date de livraison estimee. */
      var date = dateEstimee(parSlot.livraison);
      /* une fenêtre plutôt qu'une date seule (Max, 23/10, 14 h : « Livraison estimée vers le vendredi 13 novembre :
         rajouter « au plus tard », et « au plus tôt » avant, donc en 5 jours » ; fiche wk-produit-galerie-scroll-droite) :
         au plus tôt 5 jours ouvrés, au plus tard le délai du volet Livraison */
      var tot = date && dateEstimee(parSlot.livraison, 5);
      if (date) {
        var eta = document.createElement('p');
        eta.className = 'bmv4__eta';
        eta.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg><span></span>';
        /* Les deux dates se démarquent, un reflet passe une fois à l'ouverture ; à droite, le panier, noir et plein
           (Max, 26/10, 16 h : « dans la cellule Livraison au plus tôt…, je veux un bouton Ajouter au panier en noir,
           et que la livraison au plus tôt et au plus tard […] se démarque, genre un effet de reflet » ;
           fiche a26-fiche-en-savoir-plus). */
        var phrase = eta.querySelector('span');
        phrase.className = 'bmv8-eta__txt';
        var fenetre = tot && tot !== date;
        /* Fenêtre (ordinateur et téléphone) : une phrase, une date, seule la date en gras ; le bloc et son bouton
           tiennent en deux lignes au plus (Max, 27/10, 18 h 30 : « trois lignes, c'est interdit », « juste de mettre
           en gras livraison plutôt le mardi 3 novembre » ; fiche b27-fiche-en-savoir-plus). La date : celle du « au
           plus tôt » d'avant. */
        /* sans la clé (ja, es pour l'instant), la phrase déjà traduite à une date plutôt que du français */
        var auPlusTot = I18N.stack_eta_tot || (/^fr/i.test(document.documentElement.lang || 'fr') ? '' : I18N.stack_eta) || 'Livraison au plus tôt le {date}';
        var gabarit = FEN ? auPlusTot.replace('{date}', '{tot}')
          : fenetre ? t('stack_eta_fenetre', 'Livraison au plus tôt le {tot}, au plus tard le {date}')
          : t('stack_eta', 'Livraison estimée vers le {date}');
        if (FEN && !tot) gabarit = gabarit.replace('{tot}', '{date}');
        gabarit.split(/(\{tot\}|\{date\})/).forEach(function (bout) {
          if (bout === '{tot}' || bout === '{date}') {
            var d8 = document.createElement('b');
            d8.className = 'bmv8-date';
            d8.textContent = bout === '{tot}' ? tot : date;
            phrase.appendChild(d8);
          } else if (bout) {
            phrase.appendChild(document.createTextNode(bout));
          }
        });
        if (FEN) {
          eta.classList.add('bmv8-eta');
          atcE = document.createElement('button');
          atcE.type = 'button';
          atcE.className = 'bmv8-atc';
          atcE.innerHTML = '<span></span>';
          atcE.addEventListener('click', function () {
            var v = vraiAtc();
            if (!v || v.disabled) return;
            refermer();
            v.click();
          });
          eta.appendChild(atcE);
          etatAtc();
        }
        inner.appendChild(eta);
      }

      panneau.appendChild(inner);
      if (FEN) {
        document.body.appendChild(pile);
      } else if (FLUX) {
        pile.classList.add('bmk--flux');
        if (DESSUS) pile.classList.add('bmk--dessus');
        colonne.classList.add('bmk-host', 'bmk-host--flux');
        rangeeAchat.insertAdjacentElement(DESSUS ? 'beforebegin' : 'afterend', pile);
      } else if (colonne) {
        colonne.classList.add('bmk-host');
        colonne.appendChild(pile);
      } else {
        document.body.appendChild(pile);
      }

      /* Ordinateur : le rectangle des choix seulement — du bas du cartel au
         haut de la rangee d'achat, mesure bloc ferme (getBoundingClientRect
         donne la taille vue, zoom du bloc compris). La rangee d'achat et la
         ligne de paiement restent a leur place, visibles et actives (v4). */
      function placer() {
        if (FEN) { placerCarre(); return; }
        var cotes = ['top', 'left', 'width', 'height'];
        if (FLUX || !mq.matches || !colonne) { cotes.forEach(function (p) { pile.style.removeProperty(p); }); return; }
        var bloc = colonne.querySelector('.bisou-s1-sticky');
        var haut = colonne.querySelector('.bisou-s1-sticky > .rv5-cartel-row') || colonne.querySelector('.bisou-s1-sticky > .rv5-top-bar');
        var rangee = colonne.querySelector('.bisou-s1-sticky > .bisou-buy-row');
        if (!bloc || !haut || !rangee) return;
        var c = colonne.getBoundingClientRect();
        var b = bloc.getBoundingClientRect();
        var debut = haut.getBoundingClientRect().bottom;
        var fin = rangee.getBoundingClientRect().top;
        pile.style.top = Math.round(debut - c.top) + 'px';
        pile.style.left = Math.round(b.left - c.left) + 'px';
        pile.style.width = Math.round(b.width) + 'px';
        pile.style.height = Math.max(0, Math.round(fin - debut)) + 'px';
      }

      /* v7 : le panneau prend le carre des images, mesure a l'ouverture (la
         page ne defile pas tant qu'il est ouvert). Au telephone, ou sans
         carre trouve : la fenetre (plein ecran au telephone). */
      function placerCarre() {
        var cotes = ['--bmk7-x', '--bmk7-y', '--bmk7-w', '--bmk7-h'];
        /* le bloc de droite, plus l'image (Max, 23/10, 14 h : « en savoir plus doit avoir lieu sur le bloc de droite » ;
           fiche wk-produit-galerie-scroll-droite) : l'image reste visible à gauche, le volet prend la partie visible de
           la colonne du tirage ; sans elle, le carré des images comme avant */
        var g = CARRE && mq.matches && (document.querySelector('.product__info-wrapper') || document.querySelector('.rv5-media-frame .product__column-sticky') || document.querySelector('.bisou-gallery--multi'));
        var r = g && g.getBoundingClientRect();
        /* La part du carre a l'ecran : trop peu (page descendue vers
           Associez-le), c'est la fenetre. */
        var vu = r ? Math.min(r.bottom, window.innerHeight) - Math.max(0, r.top) : 0;
        var ok = !!(r && r.width > 240 && vu > 420);
        pile.classList.toggle('is-carre', ok);
        cotes.forEach(function (p) { pile.style.removeProperty(p); });
        if (!ok) return;
        [r.left, Math.max(0, r.top), r.width, vu].forEach(function (v, i) {
          pile.style.setProperty(cotes[i], Math.round(v) + 'px');
        });
      }

      /* Le declencheur fait l'aller et le retour : ouvert, il devient
         « Fermer », a la meme largeur — le panier, a cote, ne bouge pas
         d'un pixel (un libelle plus long le resserrait de 30 px a 1 440). */
      function lanceurEtat(ouvert) {
        var l = anchor.querySelector('.bmk-launch');
        if (!l) return null;
        if (ouvert) {
          if (!l.hasAttribute('data-ferme')) {
            if (mq.matches) l.style.minWidth = l.offsetWidth + 'px';
            l.setAttribute('data-ferme', l.innerHTML);
          }
          l.innerHTML = X + '<span>' + t('stack_close', 'Fermer') + '</span>';
          l.classList.add('is-open');
        } else if (l.hasAttribute('data-ferme')) {
          l.innerHTML = l.getAttribute('data-ferme');
          l.removeAttribute('data-ferme');
          l.style.removeProperty('min-width');
          l.classList.remove('is-open');
        }
        l.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        return l;
      }

      /* Telephone : amene la tete d'un bloc juste sous l'en-tete du site.
         L'en-tete (bandeau compris) revient quand la page remonte : on
         s'arrete donc sous lui, jamais dessous. */
      function amenerSousEntete(el, doux) {
        var r = el.getBoundingClientRect();
        var css = window.getComputedStyle(document.documentElement);
        var entete = (parseFloat(css.getPropertyValue('--announcement-bar-height')) || 0) +
          (parseFloat(css.getPropertyValue('--header-height')) || 0);
        var cible = Math.max(0, window.scrollY + r.top - entete - 12);
        try { window.scrollTo({ top: cible, behavior: doux ? 'smooth' : 'instant' }); } catch (err) { window.scrollTo(0, cible); }
      }

      /* v6 : ouvert dans la page, le bloc peut depasser la fenetre. Le calage
         de la molette (installDesktopMagneticScroll) se retire tant que le
         module est ouvert : on lit la fin d'une partie a la molette, comme
         une page. Il revient a la fermeture, sauf si l'adresse l'avait deja
         retire (?product_scroll=free). */
      var libereParMoi = false;
      function libererDefilement(on) {
        var h = document.documentElement;
        if (on && !h.classList.contains('bisou-product-scroll-free')) { h.classList.add('bisou-product-scroll-free'); libereParMoi = true; }
        else if (!on && libereParMoi) { h.classList.remove('bisou-product-scroll-free'); libereParMoi = false; }
      }

      /* v6 : le format et la finition restent a portee. Un changement,
         module ouvert, refait les parties sur place (cotes, cadre ou marge
         blanche) ; la partie ouverte reste ouverte. */
      var minuteurChoix = null;
      function choixChange(e) {
        if (!pile.classList.contains('is-open') || pile.contains(e.target)) return;
        if (!e.target.closest || !e.target.closest('.rv5-format-list, .rv5-finish-container, variant-selects')) return;
        clearTimeout(minuteurChoix);
        minuteurChoix = setTimeout(function () { if (pile.classList.contains('is-open')) remplir(true); }, 160);
      }
      if (FLUX) { bloc1.addEventListener('click', choixChange); bloc1.addEventListener('change', choixChange); }

      /* v6, ordinateur : le bloc est centre dans sa colonne. Ouvert, il
         resterait centre et remonterait de la moitie du module — le bouton
         « Fermer » partirait sous la souris. On le cale donc ou il etait,
         mesure ferme, et il grandit vers le bas. */
      function ancrer(on) {
        if (!FLUX) return;
        if (!on) { colonne.classList.remove('bmk-ancre'); colonne.style.removeProperty('--bmk-ancre'); return; }
        if (!mq.matches || window.getComputedStyle(colonne).justifyContent !== 'center') return;
        var h = bloc1.getBoundingClientRect().top - colonne.getBoundingClientRect().top;
        colonne.style.setProperty('--bmk-ancre', Math.max(0, Math.round(h)) + 'px');
        colonne.classList.add('bmk-ancre');
      }

      /* v7 : ouvert, la page ne defile pas (molette, doigt), sans retirer sa
         barre, pour que rien ne bouge d'un pixel derriere ; un toucher hors
         du panneau ferme (sur le carre, le clic suit son cours : choisir un
         format ou ajouter au panier ferme et fait ce qu'il dit). */
      function bloquer(e) {
        if (panneau.contains(e.target) && panneau.scrollHeight > panneau.clientHeight + 1) return;
        if (e.cancelable) e.preventDefault();
      }
      function aCote(e) {
        if (!pile.classList.contains('is-open') || panneau.contains(e.target) || anchor.contains(e.target)) return;
        refermer();
      }
      function ecouter(on) {
        var f = on ? 'addEventListener' : 'removeEventListener';
        document[f]('wheel', bloquer, { passive: false });
        document[f]('touchmove', bloquer, { passive: false });
        document[f]('pointerdown', aCote, true);
      }

      /* ── Ouvrir, fermer ── */
      function ouvrir() {
        /* v7 : rien ne change dans le bloc ; le declencheur garde son nom
           (la fenetre a sa croix), le focus va a la croix. */
        if (FEN) {
          remplir();
          placer();
          pile.removeAttribute('hidden');
          pile.classList.add('is-mounted');
          libererDefilement(true);
          ecouter(true);
          document.documentElement.classList.add('bmk7-open');
          var l7 = anchor.querySelector('.bmk-launch');
          if (l7) l7.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(function () {
            pile.classList.add('is-open');
            try { croix.focus({ preventScroll: true }); } catch (err) { croix.focus(); }
          });
          return;
        }
        ancrer(true);
        remplir();
        placer();
        pile.removeAttribute('hidden');
        pile.classList.add('is-mounted');
        requestAnimationFrame(function () {
          pile.classList.add('is-open');
          if (FLUX) libererDefilement(true);
          if (colonne) colonne.classList.add(FLUX ? 'bmk-lit' : 'bmk-on');
          /* Les points de navigation de la page (.bmx-slide-dots, fixes a
             droite) s'effacent tant qu'on lit. */
          document.documentElement.classList.add('bmk-open');
          /* Le focus reste sur le declencheur, devenu « Fermer » ; le
             panier est juste a cote. */
          var l = lanceurEtat(true);
          if (l) { try { l.focus({ preventScroll: true }); } catch (err) { l.focus(); } }
          /* Telephone : le module vit dans le flux, sous l'en-tete du bloc.
             On amene la page sur le bloc, apres bmk-on (60 ms : voir le
             retour du 20/10, 19 h 24). v6 : le module s'ouvre sous le doigt,
             la page ne saute plus ; elle descend seulement s'il naissait
             sous le bas de l'ecran. */
          if (FLUX) {
            var pr = pile.getBoundingClientRect();
            var bas = window.innerHeight - Math.min(220, window.innerHeight * 0.3);
            if (pr.top > bas) {
              try { window.scrollBy({ top: pr.top - bas, behavior: 'smooth' }); } catch (err) { window.scrollBy(0, pr.top - bas); }
            }
          } else if (!mq.matches) {
            setTimeout(function () {
              var bloc = colonne && colonne.querySelector('.bisou-s1-sticky');
              if (pile.classList.contains('is-open')) amenerSousEntete(bloc || pile, true);
            }, 60);
          }
        });
      }
      function refermer() {
        if (FEN) {
          pile.classList.remove('is-open');
          libererDefilement(false);
          ecouter(false);
          document.documentElement.classList.remove('bmk7-open');
          var l7 = anchor.querySelector('.bmk-launch');
          if (l7) {
            l7.setAttribute('aria-expanded', 'false');
            try { l7.focus({ preventScroll: true }); } catch (err) { l7.focus(); }
          }
          setTimeout(function () {
            if (pile.classList.contains('is-open')) return;
            pile.classList.remove('is-mounted');
            pile.setAttribute('hidden', '');
          }, 300);
          return;
        }
        pile.classList.remove('is-open');
        if (colonne) colonne.classList.remove('bmk-on', 'bmk-lit');
        document.documentElement.classList.remove('bmk-open');
        /* v6 : dans la page, le module part d'un coup — un fondu laisserait
           le bloc confiance revenir sous lui, puis sauter. */
        if (FLUX) {
          libererDefilement(false);
          pile.classList.remove('is-mounted');
          pile.setAttribute('hidden', '');
          ancrer(false);
        } else {
          setTimeout(function () {
            if (pile.classList.contains('is-open')) return;
            pile.classList.remove('is-mounted');
            pile.setAttribute('hidden', '');
          }, 420);
        }
        var l = lanceurEtat(false);
        if (l) { try { l.focus({ preventScroll: true }); } catch (err) { l.focus(); } }
        /* Telephone : on ramene la page sur le bloc d'achat, d'un coup
           (relecture du 20/10 : depuis le bas, le client restait loin sous
           l'achat). v6 : le bouton « Fermer » est juste au-dessus du module,
           la page n'a pas a bouger. */
        if (!FLUX && !mq.matches && colonne) {
          var bloc = colonne.querySelector('.bisou-s1-sticky');
          if (bloc) amenerSousEntete(bloc, false);
        }
      }

      function clavier(e) {
        if (!pile.classList.contains('is-open')) return;
        if (e.key === 'Escape') { refermer(); return; }
        /* v7 : Tab tourne dans la fenetre, sans en sortir. */
        if (FEN && e.key === 'Tab') {
          var f = Array.prototype.filter.call(panneau.querySelectorAll('button, a[href]'), function (n) { return n.offsetParent !== null; });
          if (!f.length) return;
          var i = f.indexOf(document.activeElement);
          if (e.shiftKey && i <= 0) { f[f.length - 1].focus(); e.preventDefault(); }
          else if (!e.shiftKey && (i < 0 || i === f.length - 1)) { f[0].focus(); e.preventDefault(); }
        }
      }
      /* Ouvert, une fenetre d'ordinateur qui change de taille : on referme,
         le bloc se recale, le prochain clic remesure. Mesurer le bloc
         pendant qu'il est efface mesurerait un bloc qui n'est plus a sa
         place. */
      function retailler() {
        /* v7 : la fenetre ne depend pas du bloc ; elle reste ouverte (la
           barre d'un navigateur de tablette qui se replie ne la ferme pas). */
        if (FEN) { if (pile.classList.contains('is-open')) placer(); return; }
        if (pile.classList.contains('is-open') && mq.matches) refermer();
      }
      document.addEventListener('keydown', clavier);
      window.addEventListener('resize', retailler, { passive: true });

      function detruire() {
        document.removeEventListener('keydown', clavier);
        window.removeEventListener('resize', retailler);
        if (FLUX) {
          bloc1.removeEventListener('click', choixChange);
          bloc1.removeEventListener('change', choixChange);
          clearTimeout(minuteurChoix);
          libererDefilement(false);
          ancrer(false);
          colonne.classList.remove('bmk-lit', 'bmk-host--flux');
        }
        if (FEN) {
          libererDefilement(false);
          ecouter(false);
          document.documentElement.classList.remove('bmk7-open');
        }
        if (colonne) colonne.classList.remove('bmk-on');
        document.documentElement.classList.remove('bmk-open');
        if (pile.parentNode) pile.parentNode.removeChild(pile);
      }

      return {
        ouvrir: ouvrir,
        refermer: refermer,
        estOuvert: function () { return pile.classList.contains('is-open'); },
        detruire: detruire
      };
    }

    /* Bloc 2 (« Associez le ») : le bouton « mur ». Au clic, ouvre le wall
       planner en DIPTYQUE = produit principal (la page courante) + UNE carte « Associez le »
       VISIBLE à ce moment (la plus centrée dans le carrousel). Desktop uniquement. */
    function buildBloc3Atc() {
      var assoc = document.getElementById('rv5-bloc-associated');
      if (!assoc || assoc.dataset.atcBuilt) return;
      assoc.dataset.atcBuilt = '1';

      var wallHref = '/pages/framed-wall-planner';
      var oldCta = assoc.querySelector('.rv5-wall-cta');
      if (oldCta) {
        var oldLink = oldCta.querySelector('.rv5-wall-btn');
        if (oldLink && oldLink.getAttribute('href')) wallHref = oldLink.getAttribute('href');
        oldCta.style.display = 'none';
      }
      var planBase = wallHref.split('?')[0] || '/pages/framed-wall-planner';

      function handleFromUrl(u) { if (!u) return ''; var m = String(u).match(/\/products\/([^/?#]+)/); return m ? m[1].toLowerCase() : ''; }

      /* la carte associée la plus centrée dans la zone visible du carrousel */
      function pickVisibleAssoc() {
        var grid = assoc.querySelector('.rv5-associated-grid');
        if (!grid) return null;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.rv5-assoc-card'));
        if (!cards.length) return null;
        var gr = grid.getBoundingClientRect();
        var mid = gr.left + gr.width / 2;
        var best = null, bestDist = Infinity;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect();
          if (r.right < gr.left + 4 || r.left > gr.right - 4) return; /* hors zone visible */
          var d = Math.abs((r.left + r.width / 2) - mid);
          if (d < bestDist) { bestDist = d; best = c; }
        });
        return best || cards[0];
      }

      /* le bouton ET la flèche envoient tous deux vers le composer (diptyque) */
      function goToPlanner(e) {
        if (e) e.preventDefault();
        var ids = [];
        var mainH = handleFromUrl(assoc.dataset.productUrl) || handleFromUrl(window.location.pathname);
        if (mainH) ids.push(mainH);
        var card = pickVisibleAssoc();
        var assocH = card && handleFromUrl(card.getAttribute('href'));
        if (assocH && ids.indexOf(assocH) < 0) ids.push(assocH);
        window.location.href = planBase + (ids.length ? '?ids=' + ids.join(',') : '');
      }

      /* UN SEUL OBJET (Max, 28/08 : « pas clair du tout »). Il y avait une
         pilule blanche ET un cercle noir a croix qui la chevauchait — la croix
         disait « ajouter », a cote de vignettes d'achat. Reste une pilule, son
         libelle, une fleche qui dit qu'on part quelque part. Le libelle vient
         de la locale `product.wall_cta`, la meme que le bouton mobile : une
         phrase, un endroit ou la changer. */
      var row = document.createElement('div'); row.className = 'bmx-atc3row';
      var wall = document.createElement('a'); wall.className = 'bmx-wall3'; wall.href = planBase;
      var libelle = document.createElement('span'); libelle.textContent = t('wall_cta', 'Voir sur votre mur');
      wall.appendChild(libelle);
      wall.insertAdjacentHTML('beforeend', A_R);
      wall.addEventListener('click', goToPlanner);
      row.appendChild(wall);

      if (oldCta && oldCta.parentNode) { oldCta.parentNode.insertBefore(row, oldCta); }
      else { assoc.appendChild(row); }
    }

    function build() {
      var next = mq.matches ? 'd' : 'm';
      if (next === mode) return;
      mode = next;
      anchor.innerHTML = ''; mount.innerHTML = '';
      document.querySelectorAll('.bmx-sheet, .bmx-tin, .bmk').forEach(function (n) { n.remove(); });
      /* reset bloc 2 : retire la rangée ATC injectée et restaure la CTA mur d'origine */
      var assoc = document.getElementById('rv5-bloc-associated');
      if (assoc) {
        assoc.removeAttribute('data-atc-built');
        var injected = assoc.querySelector('.bmx-atc3row'); if (injected) injected.remove();
        var origCta = assoc.querySelector('.rv5-wall-cta'); if (origCta) origCta.style.display = '';
      }
      document.documentElement.classList.remove('bmx-detail-open', 'bmx-slides');
      document.documentElement.style.removeProperty('overflow');

      /* Le module precedent part avec ses ecouteurs et ses classes d'etat :
         une colonne sans module derriere ne doit jamais rester effacee. */
      if (moduleCourant) { moduleCourant.detruire(); moduleCourant = null; }
      moduleCourant = buildPostale();
      ouvrirCourant = moduleCourant.ouvrir;

      /* Le declencheur : petit a droite du panier sur ordinateur, pleine
         largeur sous lui sur telephone. Un seul canon — contour noir. */
      var lanceur = document.createElement('button');
      lanceur.type = 'button';
      lanceur.className = 'bmk-launch';
      var label = t('stack_open', 'En savoir plus');
      if (next === 'm') label = section.getAttribute('data-mbtn-label') || label;
      /* Un point qui pulse a gauche du libelle, comme l'ancien bouton mobile
         (Max, 28/08) : un signe de vie, pas une fleche. */
      /* 25/10 (Max : « le plus d'info est pas encore assez evident ») : au
         telephone, la ligne dit ce qu'elle cache et un « + » dit qu'elle
         s'ouvre. L'ordinateur ne montre ni l'apercu ni le « + » (CSS). */
      lanceur.innerHTML = '<span class="bmx-pulse" aria-hidden="true"></span>'
        + '<span class="bmk-launch__txt"><span class="bmk-launch__label">' + label + '</span>'
        + '<span class="bmk-launch__hint">' + t('stack_open_hint', 'Papier, cadre, certificat, livraison') + '</span></span>'
        + '<span class="bmk-launch__plus" aria-hidden="true"></span>';
      lanceur.setAttribute('aria-expanded', 'false');
      lanceur.addEventListener('click', function () {
        if (moduleCourant && moduleCourant.estOuvert()) moduleCourant.refermer();
        else if (ouvrirCourant) ouvrirCourant(0);
      });
      anchor.appendChild(lanceur);

      if (next === 'd') {
        buildBloc3Atc();
        document.documentElement.classList.add('bmx-slides');
      }
    }

    installDesktopMagneticScroll();
    build();

    /* « + d'infos » (repère sous la rangée d'achat) : visible en haut,
       s'efface au défilement. Le clic ouvre le volet sur le cartel. */
    (function setupScrollCue() {
      var link = document.querySelector('.rv5-more-link');
      if (!link) return;
      function upd() { link.classList.toggle('is-hidden', window.scrollY > window.innerHeight * 0.5); }
      upd();
      window.addEventListener('scroll', upd, { passive: true });
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (ouvrirCourant) ouvrirCourant(0);
      });
    })();

    /* ── Pourquoi ce nom, et pas « t » ──
       « var t » vivait ici, dans la portee de init(). Le pont i18n ajoute plus
       tard a declare un helper t(cle, repli) au niveau du module. Par hoisting,
       tous les t(...) ecrits DANS init() ne visaient plus le helper mais ce
       chronometre, encore undefined : « t is not a function », et le volet
       mourait a sa premiere ligne. C'est le cartel disparu d'aout.
       Le chronometre porte desormais un nom a lui. Ne pas le rappeler « t ». */
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(build, 180); });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
